
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bJeU6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hjUDQ = parcelRequire("hjUDQ");

var $5RH40 = parcelRequire("5RH40");

var $cfM7x = parcelRequire("cfM7x");










var $6461dd9a11ba8e64$exports = {};

var $9nTiU = parcelRequire("9nTiU");


var $fZvv3 = parcelRequire("fZvv3");


var $2Ryc1 = parcelRequire("2Ryc1");

/** Used as references for various `Number` constants. */ var $6461dd9a11ba8e64$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6461dd9a11ba8e64$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $6461dd9a11ba8e64$var$times(n, iteratee) {
    n = $2Ryc1(n);
    if (n < 1 || n > $6461dd9a11ba8e64$var$MAX_SAFE_INTEGER) return [];
    var index = $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH, length = $6461dd9a11ba8e64$var$nativeMin(n, $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH);
    iteratee = $fZvv3(iteratee);
    n -= $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH;
    var result = $9nTiU(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$6461dd9a11ba8e64$exports = $6461dd9a11ba8e64$var$times;



var $w6R6I = parcelRequire("w6R6I");


var $dinVW = parcelRequire("dinVW");











var $kmQhR = parcelRequire("kmQhR");





var $iMnC5 = parcelRequire("iMnC5");




var $1LXnB = parcelRequire("1LXnB");


var $4pBmf = parcelRequire("4pBmf");








var $iDrrr = parcelRequire("iDrrr");


var $j0Q3v = parcelRequire("j0Q3v");

const $09e0b7f0b9011910$export$1f7957aafeeb725b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    let t0;
    if ($[0] !== isAdvancedThemingEnabled) {
        t0 = isAdvancedThemingEnabled && (0, $iDrrr.fg)("hub-space-density");
        $[0] = isAdvancedThemingEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $iDrrr.fg)('hub-space-density');
};



var $lCJ1A = parcelRequire("lCJ1A");


var $531JC = parcelRequire("531JC");


var $gMXXV = parcelRequire("gMXXV");


var $5D0gt = parcelRequire("5D0gt");

const $1036ce2280d59186$export$ba1fe8828f2c393e = 16;
const $1036ce2280d59186$export$f4a9066d04eb34fe = 16;
const $1036ce2280d59186$var$styles = {
    flexBox: "_3iDTPbQ4SZ _1mT5xdRAKS _2Zuz6QPgdg",
    stacked: "_3TGfC9HnLE",
    row: "_4bt5LAnQyn _2WAcuGnQyn",
    left: "_37wbyuchRC",
    center: "_37wbyuDIqT",
    right: "_37wbyuz9WS"
};
const $1036ce2280d59186$export$37f8d84bb48ae4b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId } = t0;
    const isHubSpaceDensityEnabled = (0, $09e0b7f0b9011910$export$1f7957aafeeb725b)();
    const spaceDensity = (0, $4pBmf.useHubTheming)()?.spaceDensity;
    let t1;
    if ($[0] !== isHubSpaceDensityEnabled || $[1] !== spaceDensity) {
        t1 = isHubSpaceDensityEnabled && spaceDensity ? (0, $lCJ1A.getCardGapForDensity)(spaceDensity) : undefined;
        $[0] = isHubSpaceDensityEnabled;
        $[1] = spaceDensity;
        $[2] = t1;
    } else t1 = $[2];
    const gapBetweenItems = t1;
    let t2;
    if ($[3] !== cardDimensions || $[4] !== gapBetweenItems || $[5] !== numberOfCards) {
        t2 = {
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            gapBetweenItems: gapBetweenItems
        };
        $[3] = cardDimensions;
        $[4] = gapBetweenItems;
        $[5] = numberOfCards;
        $[6] = t2;
    } else t2 = $[6];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)(t2);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    let t3;
    if ($[7] !== setCurrentCardsGridWidth) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
        $[7] = setCurrentCardsGridWidth;
        $[8] = t3;
    } else t3 = $[8];
    const throttledSetWidth = t3;
    const orientation = isStacked ? "grid" : "row";
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const t4 = cards?.length;
    const t5 = !isStacked;
    let t6;
    if ($[9] !== maxNumberOfCardsPerRow || $[10] !== t4 || $[11] !== t5) {
        t6 = {
            maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
            numberOfItems: t4,
            isRow: t5
        };
        $[9] = maxNumberOfCardsPerRow;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)(t6);
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    const t7 = `link-cards-content-cards-${orientation}`;
    const t8 = isStacked ? $1036ce2280d59186$var$styles.stacked : $1036ce2280d59186$var$styles.row;
    const t9 = !isStacked || isGridSmallerOrEqualWidthToCards ? $1036ce2280d59186$var$styles.left : $1036ce2280d59186$var$styles[alignment];
    let t10;
    if ($[13] !== t8 || $[14] !== t9) {
        t10 = (0, $w6R6I.cx)($1036ce2280d59186$var$styles.flexBox, t8, t9);
        $[13] = t8;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const t11 = `${spaceBetweenCards}px`;
    let t12;
    if ($[16] !== t11) {
        t12 = {
            gap: t11
        };
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== cardDimensions || $[19] !== cardWidthOnFullRow || $[20] !== cards || $[21] !== extensionLocalId || $[22] !== isFirstRowFull || $[23] !== orientation || $[24] !== renderCard || $[25] !== requestScrollIndex || $[26] !== resetScrollIndex || $[27] !== scrollToIndex || $[28] !== setCurrentCardWidth) {
        let t14;
        if ($[30] !== cardDimensions || $[31] !== cardWidthOnFullRow || $[32] !== extensionLocalId || $[33] !== isFirstRowFull || $[34] !== orientation || $[35] !== renderCard || $[36] !== requestScrollIndex || $[37] !== resetScrollIndex || $[38] !== scrollToIndex || $[39] !== setCurrentCardWidth) {
            t14 = (card, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
                    cardId: card.cardId,
                    key: index,
                    isFirstRowFull: isFirstRowFull,
                    cardWidthOnFullRow: cardWidthOnFullRow,
                    itemDimensions: cardDimensions,
                    setWidth: index === 0 ? setCurrentCardWidth : undefined,
                    scrollToCard: index === scrollToIndex,
                    clearScrollToCard: resetScrollIndex,
                    testId: `link-cards-content-cards-${orientation}-card-${index}`,
                    index: index,
                    requestScrollIndex: requestScrollIndex,
                    extensionLocalId: extensionLocalId,
                    ariaRole: "listitem"
                }, renderCard(card));
            $[30] = cardDimensions;
            $[31] = cardWidthOnFullRow;
            $[32] = extensionLocalId;
            $[33] = isFirstRowFull;
            $[34] = orientation;
            $[35] = renderCard;
            $[36] = requestScrollIndex;
            $[37] = resetScrollIndex;
            $[38] = scrollToIndex;
            $[39] = setCurrentCardWidth;
            $[40] = t14;
        } else t14 = $[40];
        t13 = cards.map(t14);
        $[18] = cardDimensions;
        $[19] = cardWidthOnFullRow;
        $[20] = cards;
        $[21] = extensionLocalId;
        $[22] = isFirstRowFull;
        $[23] = orientation;
        $[24] = renderCard;
        $[25] = requestScrollIndex;
        $[26] = resetScrollIndex;
        $[27] = scrollToIndex;
        $[28] = setCurrentCardWidth;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[41] !== throttledSetWidth) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: throttledSetWidth,
            offscreen: true
        });
        $[41] = throttledSetWidth;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== t10 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: t7,
            xcss: t10,
            style: t12,
            role: "list"
        }, t13, t14);
        $[43] = t10;
        $[44] = t12;
        $[45] = t13;
        $[46] = t14;
        $[47] = t7;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== CardsContentFooter || $[50] !== allCardsShown || $[51] !== cards.length || $[52] !== isAtBeginning || $[53] !== isAtEnd || $[54] !== isStacked || $[55] !== scrollToNext || $[56] !== scrollToPrevious || $[57] !== showAIDisclaimer) {
        t16 = cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentFooter, {
            isStacked: isStacked,
            showAIDisclaimer: showAIDisclaimer,
            allCardsShown: allCardsShown,
            isAtBeginning: isAtBeginning,
            isAtEnd: isAtEnd,
            scrollToPrevious: scrollToPrevious,
            scrollToNext: scrollToNext
        });
        $[49] = CardsContentFooter;
        $[50] = allCardsShown;
        $[51] = cards.length;
        $[52] = isAtBeginning;
        $[53] = isAtEnd;
        $[54] = isStacked;
        $[55] = scrollToNext;
        $[56] = scrollToPrevious;
        $[57] = showAIDisclaimer;
        $[58] = t16;
    } else t16 = $[58];
    let t17;
    if ($[59] !== t15 || $[60] !== t16 || $[61] !== testId) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: testId
        }, t15, t16);
        $[59] = t15;
        $[60] = t16;
        $[61] = testId;
        $[62] = t17;
    } else t17 = $[62];
    return t17;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId })=>{
    // Space density (Default/Comfortable/Breezy) widens the horizontal gap
    // between cards. When the feature is disabled or no density is selected, the
    // gap stays at the default 16px — a no-op for existing hubs.
    const isHubSpaceDensityEnabled = (0, $09e0b7f0b9011910$export$1f7957aafeeb725b)();
    const spaceDensity = (0, $4pBmf.useHubTheming)()?.spaceDensity;
    const gapBetweenItems = isHubSpaceDensityEnabled && spaceDensity ? (0, $lCJ1A.getCardGapForDensity)(spaceDensity) : undefined;
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        gapBetweenItems: gapBetweenItems
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
    const orientation = isStacked ? 'grid' : 'row';
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: cards?.length,
        isRow: !isStacked
    });
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `link-cards-content-cards-${orientation}`,
        xcss: (0, $w6R6I.cx)($1036ce2280d59186$var$styles.flexBox, isStacked ? $1036ce2280d59186$var$styles.stacked : $1036ce2280d59186$var$styles.row, /**
     * Align left regardless of alignment if
     * - orientation is row
     * - the grid width is smaller or equal to the minimum width of the card size
     */ !isStacked || isGridSmallerOrEqualWidthToCards ? $1036ce2280d59186$var$styles.left : $1036ce2280d59186$var$styles[alignment]),
        style: {
            gap: `${spaceBetweenCards}px`
        },
        role: "list"
    }, cards.map((card, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
            cardId: card.cardId,
            key: index,
            isFirstRowFull: isFirstRowFull,
            cardWidthOnFullRow: cardWidthOnFullRow,
            itemDimensions: cardDimensions,
            setWidth: index === 0 ? setCurrentCardWidth : undefined,
            scrollToCard: index === scrollToIndex,
            clearScrollToCard: resetScrollIndex,
            testId: `link-cards-content-cards-${orientation}-card-${index}`,
            index: index,
            requestScrollIndex: requestScrollIndex,
            extensionLocalId: extensionLocalId,
            ariaRole: "listitem"
        }, renderCard(card))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: throttledSetWidth,
        offscreen: true
    })), cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentFooter, {
        isStacked: isStacked,
        showAIDisclaimer: showAIDisclaimer,
        allCardsShown: allCardsShown,
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext
    }));
};











var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");







const $0f6158376f466854$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorLoadingCardsPreamble: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-preamble",
        defaultMessage: "We\u2019re having trouble loading these cards."
    },
    errorLoadingCardsSupport: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-support",
        defaultMessage: "Reload to try again."
    }
});


const $f15264ed5f302311$var$inlineStyles = (0, $buxP3.xcss)({
    marginTop: 'space.150'
});
const $f15264ed5f302311$export$533cd3269e981a31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { error: error } = t0;
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== submitError) {
        t1 = ()=>{
            submitError?.(error);
        };
        t2 = [
            error,
            submitError
        ];
        $[0] = error;
        $[1] = submitError;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "error",
            color: "var(--ds-icon-danger, #C9372C)"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            weight: "medium",
            size: "medium",
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsPreamble));
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $f15264ed5f302311$var$inlineStyles
        }, t3, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            weight: "medium",
            size: "medium",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsSupport)));
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ error: error })=>{
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        submitError?.(error);
    }, [
        error,
        submitError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $f15264ed5f302311$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        weight: "medium",
        size: "medium",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsPreamble)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        weight: "medium",
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsSupport)));
};















const $e4389e92f972a9fa$export$93c098ff84870fcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant } = t0;
    const shouldApplySegmentation = isCompanyHub && isSegmentationShown;
    let t1;
    bb0: {
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC || renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) {
            t1 = cards;
            break bb0;
        }
        if (isDynamicOrManualWithAllTarget) {
            let t2;
            if ($[0] !== audienceSegmentationGroupIds || $[1] !== cards || $[2] !== isTargetAudience) {
                t2 = isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
                $[0] = audienceSegmentationGroupIds;
                $[1] = cards;
                $[2] = isTargetAudience;
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[4] !== cards || $[5] !== isTargetAudience) {
            let t3;
            if ($[7] !== isTargetAudience) {
                t3 = (card)=>isTargetAudience(card.audienceSegmentationGroupIds);
                $[7] = isTargetAudience;
                $[8] = t3;
            } else t3 = $[8];
            t2 = cards.filter(t3);
            $[4] = cards;
            $[5] = isTargetAudience;
            $[6] = t2;
        } else t2 = $[6];
        t1 = t2;
    }
    const filteredCards = t1;
    let t2;
    if ($[9] !== filteredCards) {
        t2 = {
            filteredCards: filteredCards
        };
        $[9] = filteredCards;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant })=>{
    const shouldApplySegmentation = (0, $cozmU.useMemo)(()=>isCompanyHub && isSegmentationShown, [
        isCompanyHub,
        isSegmentationShown
    ]);
    const filteredCards = (0, $cozmU.useMemo)(()=>{
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC || renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) return cards;
        if (isDynamicOrManualWithAllTarget) return isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
        return cards.filter((card)=>isTargetAudience(card.audienceSegmentationGroupIds));
    }, [
        isInViewMode,
        shouldApplySegmentation,
        segmentationTarget,
        cards,
        renderVariant,
        isTargetAudience,
        audienceSegmentationGroupIds
    ]);
    return {
        filteredCards: filteredCards
    };
};




const $b2481ad40679111c$export$c6c5cac0793c45d9 = (items)=>{
    const itemIdSet = (0, $cozmU.useMemo)(()=>new Set(items.map((item)=>item.cardId)), [
        items
    ]);
    const [areAllItemsLoaded, setAreAllItemsLoaded] = (0, $cozmU.useState)(false);
    const [itemFailureError, setItemFailureError] = (0, $cozmU.useState)(null);
    const onItemFailed = (0, $cozmU.useCallback)((error)=>{
        setItemFailureError(error);
    }, []);
    const onItemSucceeded = (0, $cozmU.useCallback)((itemId)=>{
        itemIdSet.delete(itemId);
        if (itemIdSet.size === 0) setAreAllItemsLoaded(true);
    }, [
        itemIdSet
    ]);
    return (0, $cozmU.useMemo)(()=>({
            areAllItemsLoaded: areAllItemsLoaded,
            itemFailureError: itemFailureError,
            onItemSucceeded: onItemSucceeded,
            onItemFailed: onItemFailed
        }), [
        areAllItemsLoaded,
        itemFailureError,
        onItemSucceeded,
        onItemFailed
    ]);
};





var $hhnRo = parcelRequire("hhnRo");


var $65u5c = parcelRequire("65u5c");


























var $8qkba = parcelRequire("8qkba");

var $619Qo = parcelRequire("619Qo");


var $8N7MV = parcelRequire("8N7MV");

var $hOJLU = parcelRequire("hOJLU");

var $4XdCR = parcelRequire("4XdCR");


var $hz3c4 = parcelRequire("hz3c4");


var $k2pUk = parcelRequire("k2pUk");

const $75b0428829020cae$var$getFilterValue = (filter)=>{
    return filter?.split(',') || [];
};
const $75b0428829020cae$var$getFilterDateRange = (filters)=>{
    const { lastModified: lastModified } = filters;
    if (lastModified && lastModified !== 'custom') return [
        (0, $hz3c4.getConfluenceDateOptionValues)(lastModified)
    ];
    else if (lastModified === 'custom') {
        if (filters?.from && filters?.to) return [
            (0, $hz3c4.getConfluenceDateOptionFromCustomDates)(filters.from, filters.to)
        ];
    }
    return [];
};
const $75b0428829020cae$var$getEntities = (type)=>{
    if (type === 'page') return [
        (0, $8N7MV.PAGE_ATI)
    ];
    else if (type === 'blogpost') return [
        (0, $8N7MV.BLOGPOST_ATI)
    ];
    return [
        (0, $8N7MV.PAGE_ATI),
        (0, $8N7MV.BLOGPOST_ATI)
    ];
};
const $75b0428829020cae$var$getConfluenceFilters = (filters)=>{
    const { spaces: spaces, owners: owners, labels: labels, contributors: contributors, ancestor: ancestor, verified: verified } = filters;
    return {
        spacesFilter: $75b0428829020cae$var$getFilterValue(spaces),
        isVerified: verified || undefined,
        contributorsFilter: $75b0428829020cae$var$getFilterValue(contributors),
        ancestorIdsFilter: $75b0428829020cae$var$getFilterValue(ancestor),
        range: $75b0428829020cae$var$getFilterDateRange(filters),
        owners: $75b0428829020cae$var$getFilterValue(owners),
        labelsFilter: $75b0428829020cae$var$getFilterValue(labels)
    };
};
const $75b0428829020cae$var$getSearchPageQueryVariables = (cardCount, filters, cloudId, searchSessionId)=>{
    const entities = $75b0428829020cae$var$getEntities(filters.type);
    return {
        query: '',
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: cardCount,
        entities: entities,
        commonFilters: {},
        confluenceFilters: $75b0428829020cae$var$getConfluenceFilters(filters),
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        queryVersion: 1,
        searchSessionId: searchSessionId ?? '',
        sort: [
            {
                field: filters.sortField || (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                order: filters.sortOrder || (0, $4XdCR.SORT_ORDER).DESC
            }
        ]
    };
};
const $75b0428829020cae$export$7bf81438544569b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $cfM7x.useProductDependencies)();
    let t0;
    if ($[0] !== searchConfigProvider) {
        t0 = searchConfigProvider || {};
        $[0] = searchConfigProvider;
        $[1] = t0;
    } else t0 = $[1];
    const { searchSessionId: searchSessionId } = t0;
    let t1;
    if ($[2] !== cloudId || $[3] !== searchSessionId) {
        t1 = async (cardCount, filters)=>{
            const variables = $75b0428829020cae$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
            const { data: data, errors: errors } = await (0, $hOJLU.searchPageQuery)({
                variables: variables
            });
            const results = data?.search.results.edges.map($75b0428829020cae$var$_temp) || [];
            if (results.length === 0) return {
                cards: [],
                errors: errors
            };
            const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
            const dynamicCards = trimmedResults?.map($75b0428829020cae$var$_temp5);
            return {
                cards: dynamicCards,
                errors: errors
            };
        };
        $[2] = cloudId;
        $[3] = searchSessionId;
        $[4] = t1;
    } else t1 = $[4];
    const getDynamicCards = t1;
    let t2;
    if ($[5] !== getDynamicCards) {
        t2 = {
            getDynamicCards: getDynamicCards
        };
        $[5] = getDynamicCards;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $cfM7x.useProductDependencies)();
    const { searchSessionId: searchSessionId } = searchConfigProvider || {};
    const getDynamicCards = (0, $cozmU.useCallback)(async (cardCount, filters)=>{
        const variables = $75b0428829020cae$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
        const { data: data, errors: errors } = await (0, $hOJLU.searchPageQuery)({
            variables: variables
        });
        const results = data?.search.results.edges.map((edge)=>edge.node) || [];
        if (results.length === 0) return {
            cards: [],
            errors: errors
        };
        const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
        const dynamicCards = trimmedResults?.map((result)=>{
            const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
            const newCard = (0, $k2pUk.createNewCardWithDefaultParameters)();
            newCard.link = url;
            newCard.title = title;
            newCard.description = description;
            newCard.confluencePageId = id.split('/')[1];
            if (confluenceEntity) {
                const { subtype: subtype, properties: properties } = confluenceEntity;
                const isLivePage = subtype === 'live';
                let imageProperty;
                if (isLivePage) imageProperty = properties?.find((image)=>image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
                else {
                    imageProperty = properties?.find((image_0)=>image_0?.key === (0, $8qkba.CoverPictureIdPropertyKey).PUBLISHED);
                    if (!imageProperty) imageProperty = properties?.find((image_1)=>image_1?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
                }
                let imageSrc = (0, $8qkba.propertyToId)(imageProperty)?.value?.id;
                if (imageSrc && !(0, $619Qo.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
                newCard.imageSrc = imageSrc;
            }
            return newCard;
        });
        return {
            cards: dynamicCards,
            errors: errors
        };
    }, [
        cloudId,
        searchSessionId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            getDynamicCards: getDynamicCards
        }), [
        getDynamicCards
    ]);
};
function $75b0428829020cae$var$_temp(edge) {
    return edge.node;
}
function $75b0428829020cae$var$_temp2(image) {
    return image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT;
}
function $75b0428829020cae$var$_temp3(image_0) {
    return image_0?.key === (0, $8qkba.CoverPictureIdPropertyKey).PUBLISHED;
}
function $75b0428829020cae$var$_temp4(image_1) {
    return image_1?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT;
}
function $75b0428829020cae$var$_temp5(result) {
    const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
    const newCard = (0, $k2pUk.createNewCardWithDefaultParameters)();
    newCard.link = url;
    newCard.title = title;
    newCard.description = description;
    newCard.confluencePageId = id.split("/")[1];
    if (confluenceEntity) {
        const { subtype: subtype, properties: properties } = confluenceEntity;
        const isLivePage = subtype === "live";
        let imageProperty;
        if (isLivePage) imageProperty = properties?.find($75b0428829020cae$var$_temp2);
        else {
            imageProperty = properties?.find($75b0428829020cae$var$_temp3);
            if (!imageProperty) imageProperty = properties?.find($75b0428829020cae$var$_temp4);
        }
        let imageSrc = (0, $8qkba.propertyToId)(imageProperty)?.value?.id;
        if (imageSrc && !(0, $619Qo.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
        newCard.imageSrc = imageSrc;
    }
    return newCard;
}


const $6d3e30142bf823a9$export$5fe928848609fec7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (parameters)=>{
    const $ = (0, $bDgLe.c)(11);
    const { cardCount: cardCount, filters: filters } = parameters;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [cards, setCards] = (0, $cozmU.useState)(t0);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const { getDynamicCards: getDynamicCards } = (0, $75b0428829020cae$export$7bf81438544569b5)();
    let t1;
    let t2;
    if ($[1] !== cardCount || $[2] !== filters || $[3] !== getDynamicCards || $[4] !== submitError) {
        t1 = ()=>{
            if (!!cardCount && !!filters) {
                setLoading(true);
                setError(null);
                let isActive = true;
                getDynamicCards(cardCount, filters).then((t3)=>{
                    const { cards: dynamicCards, errors: aggErrors } = t3;
                    if (!isActive) return;
                    if (aggErrors) {
                        const error_0 = new Error(JSON.stringify(aggErrors));
                        if (dynamicCards.length === 0) setError(error_0);
                        else submitError?.(error_0);
                    }
                    setCards(dynamicCards);
                }).catch((err)=>{
                    if (!isActive) return;
                    setError(err);
                }).finally(()=>{
                    if (!isActive) return;
                    setLoading(false);
                });
                return ()=>{
                    isActive = false;
                };
            }
        };
        t2 = [
            getDynamicCards,
            cardCount,
            filters,
            submitError
        ];
        $[1] = cardCount;
        $[2] = filters;
        $[3] = getDynamicCards;
        $[4] = submitError;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== cards || $[8] !== error || $[9] !== loading) {
        t3 = {
            cards: cards,
            loading: loading,
            error: error
        };
        $[7] = cards;
        $[8] = error;
        $[9] = loading;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (parameters)=>{
    const { cardCount: cardCount, filters: filters } = parameters;
    const [cards, setCards] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const { getDynamicCards: getDynamicCards } = (0, $75b0428829020cae$export$7bf81438544569b5)();
    (0, $cozmU.useEffect)(()=>{
        if (!!cardCount && !!filters) {
            setLoading(true);
            setError(null);
            let isActive = true;
            getDynamicCards(cardCount, filters).then(({ cards: dynamicCards, errors: aggErrors })=>{
                if (!isActive) return;
                if (aggErrors) {
                    const error_0 = new Error(JSON.stringify(aggErrors));
                    if (dynamicCards.length === 0) setError(error_0);
                    else submitError?.(error_0);
                }
                setCards(dynamicCards);
            }).catch((err)=>{
                if (!isActive) return;
                setError(err);
            }).finally(()=>{
                if (!isActive) return;
                setLoading(false);
            });
            return ()=>{
                isActive = false;
            };
        }
    }, [
        getDynamicCards,
        cardCount,
        filters,
        submitError
    ]);
    return (0, $cozmU.useMemo)(()=>({
            cards: cards,
            loading: loading,
            error: error
        }), [
        cards,
        loading,
        error
    ]);
};



var $9BXp4 = parcelRequire("9BXp4");




var $ikd73 = parcelRequire("ikd73");



const $f73aa100a9fdb106$var$checkIsParameterValueValid = (parameter, expectedValues)=>{
    return expectedValues.includes(parameter) ? parameter : null;
};
const $f73aa100a9fdb106$var$checkSize = (size)=>$f73aa100a9fdb106$var$checkIsParameterValueValid(size, [
        (0, $hjUDQ.Height).SMALL,
        (0, $hjUDQ.Height).MEDIUM,
        (0, $hjUDQ.Height).LARGE
    ]);
const $f73aa100a9fdb106$var$checkLayout = (layout)=>$f73aa100a9fdb106$var$checkIsParameterValueValid(layout, [
        (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT,
        (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    ]);
const $f73aa100a9fdb106$export$9a666555160249c1 = (currentParameters)=>{
    const validatedCards = (0, $9BXp4.checkItems)(currentParameters.cards);
    const validatedSize = $f73aa100a9fdb106$var$checkSize(currentParameters.size);
    const validatedLayout = $f73aa100a9fdb106$var$checkLayout(currentParameters.layout);
    const validatedRequiredParameters = {
        ...currentParameters,
        size: validatedSize || (0, $hjUDQ.Height).MEDIUM,
        cards: validatedCards || [],
        layout: validatedLayout || (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    };
    const { orientation: orientation, alignment: alignment, isAutoscrollEnabled: isAutoscrollEnabled } = validatedRequiredParameters;
    return {
        ...validatedRequiredParameters,
        // if alignment is not available (cards created before alignment), default to center
        alignment: alignment ?? (0, $ikd73.Alignment).CENTER,
        // if orientation is not available (cards created before orientation), default to stacked
        orientation: orientation ?? (0, $ikd73.Orientation).STACKED,
        isAutoscrollEnabled: orientation === (0, $ikd73.Orientation).STACKED ? false : isAutoscrollEnabled,
        // if audience segmentation new format is enabled and params are outdated, use the first card's audience segmentation group ids
        audienceSegmentationGroupIds: currentParameters.segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL && currentParameters.audienceSegmentationGroupIds === undefined ? currentParameters.cards[0]?.audienceSegmentationGroupIds : currentParameters?.audienceSegmentationGroupIds
    };
};

















var $hekY6 = parcelRequire("hekY6");








var $1sCHt = parcelRequire("1sCHt");


var $k5vii = parcelRequire("k5vii");


var $fZ6J4 = parcelRequire("fZ6J4");




var $1l0kj = parcelRequire("1l0kj");










var $32chb = parcelRequire("32chb");




const $c4a2c67793caa51b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    pause: {
        id: "company-hub.cards-extension.autoscroll-wrapper.pause",
        defaultMessage: "Pause"
    },
    play: {
        id: "company-hub.cards-extension.autoscroll-wrapper.play",
        defaultMessage: "Play"
    }
});


const $508f24952640e58a$export$ba1fe8828f2c393e = 16;
const $508f24952640e58a$export$f4a9066d04eb34fe = 16;
const $508f24952640e58a$var$wrapperStyles = null;
const $508f24952640e58a$var$pausedStyles = null;
const $508f24952640e58a$var$scrollAnimation = null;
const $508f24952640e58a$var$styles = {
    iconBackgroundStyles: "_0bjKvDS5Zs _0KLXruoI2d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconPadding: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    cardsGroup: "_3iDTPbQ4SZ",
    container: "_1mT5xdRAKS"
};
const $508f24952640e58a$var$unboundedStyles = {
    wrapperStyles: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4c065UFQfX _1mT5xdRAKS"
};
const $508f24952640e58a$var$animationStyles = null;
const $508f24952640e58a$var$shortDuration = null;
const $508f24952640e58a$var$mediumDuration = null;
const $508f24952640e58a$var$longDuration = null;
const $508f24952640e58a$export$ac70d6b7d7a09503 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId } = t0;
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isPaused) {
        t1 = ()=>setIsPaused(!isPaused);
        $[0] = isPaused;
        $[1] = t1;
    } else t1 = $[1];
    const handlePauseClick = t1;
    let t2;
    if ($[2] !== cardDimensions || $[3] !== numberOfCards) {
        t2 = {
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions
        };
        $[2] = cardDimensions;
        $[3] = numberOfCards;
        $[4] = t2;
    } else t2 = $[4];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)(t2);
    let t3;
    if ($[5] !== setCurrentCardsGridWidth) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
        $[5] = setCurrentCardsGridWidth;
        $[6] = t3;
    } else t3 = $[6];
    const throttledSetWidth = t3;
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    let t4;
    if ($[7] !== cardWidthOnFullRow || $[8] !== cards || $[9] !== isAnimationEnabled || $[10] !== numberOfCards || $[11] !== renderCard) {
        t4 = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    gap: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`,
                    paddingRight: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`
                },
                className: (0, $hekY6.default)([
                    $508f24952640e58a$var$styles.cardsGroup,
                    isAnimationEnabled && "",
                    isAnimationEnabled && "_2fBhteVuHh _39Ohv4YbGa",
                    numberOfCards <= 5 ? "_0nFVCG4dff" : numberOfCards <= 10 ? "_0nFVCGIa5E" : "_0nFVCGjMmJ"
                ])
            }, cards.map((card, cardIndex)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                    key: cardIndex
                }, /*#__PURE__*/ $cozmU.createElement("div", {
                    style: {
                        minWidth: `${cardWidthOnFullRow}px`,
                        maxWidth: `${cardWidthOnFullRow}px`
                    },
                    className: (0, $hekY6.default)([
                        $508f24952640e58a$var$unboundedStyles.wrapperStyles
                    ])
                }, renderCard(card)))));
        $[7] = cardWidthOnFullRow;
        $[8] = cards;
        $[9] = isAnimationEnabled;
        $[10] = numberOfCards;
        $[11] = renderCard;
        $[12] = t4;
    } else t4 = $[12];
    const renderCardsGroup = t4;
    const t5 = isPaused && "_2qo2jFP4vI";
    let t6;
    if ($[13] !== t5) {
        t6 = (0, $hekY6.default)([
            "_4bt5LAnQyn _3iDTPbQ4SZ _4xIiY0P4vI",
            t5
        ]);
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== renderCardsGroup) {
        t7 = renderCardsGroup();
        $[15] = renderCardsGroup;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== isAnimationEnabled || $[18] !== renderCardsGroup) {
        t8 = isAnimationEnabled && renderCardsGroup();
        $[17] = isAnimationEnabled;
        $[18] = renderCardsGroup;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== throttledSetWidth) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
            setWidth: throttledSetWidth,
            offscreen: true
        });
        $[20] = throttledSetWidth;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "cards-autoscroll-wrapper",
            className: t6
        }, t7, t8, t9);
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== handlePauseClick || $[28] !== isAnimationEnabled || $[29] !== isPaused || $[30] !== showAIDisclaimer) {
        t11 = isAnimationEnabled && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignInline: "start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $508f24952640e58a$var$styles.iconPadding
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $508f24952640e58a$var$styles.iconBackgroundStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))) : (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
            label: isPaused ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).play) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).pause),
            onClick: handlePauseClick
        })), showAIDisclaimer && /*#__PURE__*/ $cozmU.createElement((0, $32chb.CardsAIDisclaimer), null))));
        $[27] = handlePauseClick;
        $[28] = isAnimationEnabled;
        $[29] = isPaused;
        $[30] = showAIDisclaimer;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== t10 || $[33] !== t11 || $[34] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: testId,
            xcss: $508f24952640e58a$var$styles.container,
            space: "space.075"
        }, t10, t11);
        $[32] = t10;
        $[33] = t11;
        $[34] = testId;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId })=>{
    // there are 2 ways to pause the autoscroll
    // 1. Hover over a card. Should resume back to speed when unhovered
    // 2. Pause button click. Should resume when clicked again. This is implemented to meet a11y standards
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(false);
    const handlePauseClick = ()=>setIsPaused(!isPaused);
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    const renderCardsGroup = ()=>/*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        , {
            style: {
                gap: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`,
                paddingRight: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`
            },
            className: (0, $hekY6.default)([
                $508f24952640e58a$var$styles.cardsGroup,
                isAnimationEnabled && "",
                isAnimationEnabled && "_2fBhteVuHh _39Ohv4YbGa",
                numberOfCards <= 5 ? "_0nFVCG4dff" : numberOfCards <= 10 ? "_0nFVCGIa5E" : "_0nFVCGjMmJ"
            ])
        }, cards.map((card, cardIndex)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                key: cardIndex
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    minWidth: `${cardWidthOnFullRow}px`,
                    maxWidth: `${cardWidthOnFullRow}px`
                },
                className: (0, $hekY6.default)([
                    $508f24952640e58a$var$unboundedStyles.wrapperStyles
                ])
            }, renderCard(card)));
        })); // we are making a duplicate call to renderCardsGroup to make the infinte scroll experience more seamless
    // duplicate call is only required when animation is enabled, meaning there is overflow of cards than the number of cards a row can fit
    // in which case, no autoscroll will take effect
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: testId,
        xcss: $508f24952640e58a$var$styles.container,
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "cards-autoscroll-wrapper",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _3iDTPbQ4SZ _4xIiY0P4vI",
            isPaused && "_2qo2jFP4vI"
        ])
    }, renderCardsGroup(), isAnimationEnabled && renderCardsGroup(), /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
        setWidth: throttledSetWidth,
        offscreen: true
    })), isAnimationEnabled && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignInline: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $508f24952640e58a$var$styles.iconPadding
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $508f24952640e58a$var$styles.iconBackgroundStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))) : (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
        label: isPaused ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).play) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).pause),
        onClick: handlePauseClick
    })), showAIDisclaimer && /*#__PURE__*/ $cozmU.createElement((0, $32chb.CardsAIDisclaimer), null)))));
};








const $0f285ce5da73768c$export$efa81a508b70a345 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $0f285ce5da73768c$export$f86a06fd1ecacb03 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 240,
        maxWidth: 294,
        height: 84
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        height: 320
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        height: 320
    }
};
const $0f285ce5da73768c$export$6909d5bfaed761e6 = {
    [(0, $hjUDQ.Height).SMALL]: {
        ...$0f285ce5da73768c$export$f86a06fd1ecacb03[(0, $hjUDQ.Height).SMALL]
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        minHeight: 52,
        maxHeight: 348
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        minHeight: 64,
        maxHeight: 424
    }
};


const $7ee74d072d6273e0$export$90cc9ab68d35b5b9 = ({ cardSize: cardSize, layout: layout })=>{
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return (0, $0f285ce5da73768c$export$6909d5bfaed761e6)[cardSize];
    // Default to flexible dimensions (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return (0, $0f285ce5da73768c$export$f86a06fd1ecacb03)[cardSize];
};



























var $cvDI4 = parcelRequire("cvDI4");

var $4buyQ = parcelRequire("4buyQ");

var $6gjqU = parcelRequire("6gjqU");

var $fEbt0 = parcelRequire("fEbt0");

var $keB0x = parcelRequire("keB0x");

var $4yYAm = parcelRequire("4yYAm");

var $es2gJ = parcelRequire("es2gJ");

var $7j5Rg = parcelRequire("7j5Rg");


var $QXwxo = parcelRequire("QXwxo");

















var $4aRua = parcelRequire("4aRua");


var $jWbXj = parcelRequire("jWbXj");

var $4yUlE = parcelRequire("4yUlE");




const $a585f263cb2be9f9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderLabel: {
        id: "company-hub.company-hub-common.ui.empty-state.label-placeholder",
        defaultMessage: "LABEL"
    }
});


const $d187d3f4498a1480$var$styles = {
    label: "_0bjKvDzXzM _1Znuxb1Y8M _2Zuz6Q1Y8M"
};
const $d187d3f4498a1480$export$bc1a48e1b7ed7af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { label: label, labelColor: labelColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $a585f263cb2be9f9$export$defe85febe8b728c).emptyStatePlaceholderLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    const labelFinal = t1;
    const labelColorFinal = labelColor ?? (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $4yUlE.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? "color.text" : "color.text.inverse";
    let t2;
    if ($[3] !== labelColorFinal) {
        t2 = {
            backgroundColor: labelColorFinal
        };
        $[3] = labelColorFinal;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $d187d3f4498a1480$var$styles.label
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== labelFinal) {
        t4 = labelFinal?.toUpperCase();
        $[6] = labelFinal;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== labelTextColorFinal || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: labelTextColorFinal,
            size: "small",
            maxLines: 1,
            weight: "bold"
        }, t4);
        $[8] = labelTextColorFinal;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t2 || $[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t2,
            className: t3
        }, t5);
        $[11] = t2;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ label: label, labelColor: labelColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelFinal = label || formatMessage((0, $a585f263cb2be9f9$export$defe85febe8b728c).emptyStatePlaceholderLabel);
    const labelColorFinal = labelColor ?? (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $cozmU.useMemo)(()=>{
        return (0, $4yUlE.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? 'color.text' : 'color.text.inverse';
    }, [
        labelColorFinal
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: labelColorFinal
        },
        className: (0, $hekY6.default)([
            $d187d3f4498a1480$var$styles.label
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: labelTextColorFinal,
        size: "small",
        maxLines: 1,
        weight: "bold"
    }, labelFinal?.toUpperCase()));
};

















var $9GVkD = parcelRequire("9GVkD");














var $iRKv3 = parcelRequire("iRKv3");


var $4sYZY = parcelRequire("4sYZY");

const $2e96401708fc6284$var$DARK_THRESHOLD = 50;
const $2e96401708fc6284$var$convertToHoveredShade = (hexColor)=>{
    const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(hexColor);
    if (lightnessPercentage === undefined) return hexColor;
    // Lighten dark colors; darken light colors slightly based on LCH lightness
    // 0 - 100 dark to light
    const LIGHTEN_TO = Math.min(100, Math.round(lightnessPercentage + 10));
    const DARKEN_TO = Math.max(0, Math.round(lightnessPercentage - 10));
    if (lightnessPercentage < $2e96401708fc6284$var$DARK_THRESHOLD) return (0, $iRKv3.increaseLightness)(hexColor, LIGHTEN_TO);
    return (0, $iRKv3.reduceLightness)(hexColor, DARKEN_TO);
};
const $2e96401708fc6284$export$8af9b0107e419002 = (backgroundColor)=>{
    const tokenizedHoveredBackgroundColor = (0, $4sYZY.getBackgroundHoveredColor)(backgroundColor);
    if (tokenizedHoveredBackgroundColor) return tokenizedHoveredBackgroundColor;
    const convertedColor = (0, $4yUlE.convertLegacyColor)(backgroundColor);
    if (convertedColor.isValid()) return $2e96401708fc6284$var$convertToHoveredShade(convertedColor.toHexString());
    return backgroundColor;
};


const $37e5cd8620e57bb3$export$1b6000962053a12c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (color)=>{
    const $ = (0, $bDgLe.c)(11);
    const [backgroundColor, setBackgroundColor] = (0, $cozmU.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $cozmU.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== color) {
        t0 = ()=>{
            const hoveredBgColor = color ? (0, $2e96401708fc6284$export$8af9b0107e419002)(color) : undefined;
            setBackgroundColor(color);
            setShownBackgroundColor(color);
            setHoveredBackgroundColor(hoveredBgColor);
        };
        t1 = [
            color
        ];
        $[0] = color;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== hoveredBackgroundColor) {
        t2 = ()=>{
            setShownBackgroundColor(hoveredBackgroundColor);
        };
        $[3] = hoveredBackgroundColor;
        $[4] = t2;
    } else t2 = $[4];
    const handleHover = t2;
    let t3;
    if ($[5] !== backgroundColor) {
        t3 = ()=>{
            setShownBackgroundColor(backgroundColor);
        };
        $[5] = backgroundColor;
        $[6] = t3;
    } else t3 = $[6];
    const handleUnhover = t3;
    const t4 = shownBackgroundColor || backgroundColor;
    let t5;
    if ($[7] !== handleHover || $[8] !== handleUnhover || $[9] !== t4) {
        t5 = {
            backgroundColor: t4,
            handleHover: handleHover,
            handleUnhover: handleUnhover
        };
        $[7] = handleHover;
        $[8] = handleUnhover;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (color)=>{
    const [backgroundColor, setBackgroundColor] = (0, $cozmU.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $cozmU.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const hoveredBgColor = color ? (0, $2e96401708fc6284$export$8af9b0107e419002)(color) : undefined;
        setBackgroundColor(color);
        setShownBackgroundColor(color);
        setHoveredBackgroundColor(hoveredBgColor);
    }, [
        color
    ]);
    const handleHover = (0, $cozmU.useCallback)(()=>{
        setShownBackgroundColor(hoveredBackgroundColor);
    }, [
        hoveredBackgroundColor
    ]);
    const handleUnhover = (0, $cozmU.useCallback)(()=>{
        setShownBackgroundColor(backgroundColor);
    }, [
        backgroundColor
    ]);
    return {
        backgroundColor: shownBackgroundColor || backgroundColor,
        handleHover: handleHover,
        handleUnhover: handleUnhover
    };
};


var $jIDse = parcelRequire("jIDse");


var $bIp5p = parcelRequire("bIp5p");


var $eafQX = parcelRequire("eafQX");





var $51SAu = parcelRequire("51SAu");





var $4WDWC = parcelRequire("4WDWC");




const $0589719409b932c8$var$message = (0, $kSwu1.defineMessages)({
    selectToEditAriaLabel: {
        id: "company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label",
        defaultMessage: "Select card to edit"
    }
});
var $0589719409b932c8$export$2e2bcd8739ae039 = $0589719409b932c8$var$message;


const $a962904bbde7c9a2$var$unboundedStyles = {
    containerBaseUpdated: "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d _1UtDYzy7kJ _0KLXruoI2d",
    containerCorner: "_0bjKvD8fU6",
    viewOnHover: "_1eOmH6hWTW _0ReiIH7zJH",
    overlayButtonForSelectToEdit: "_30huDKYbGa _1mT5xdWVPG _0JmZspYbGa _0KLXrujOvk _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _42Yu6B7dHp",
    selectedToEdit: "_32BiAhXzJH",
    selectedToRemove: "_32BiAhOvEe _3Ku51Iogpp _3dCYwDWVPG _35I30BdnbC _1L3m71dnbC _1D2b5MdnbC _31ReDydnbC _3qT6l07dHp _2IjmTKXvJ3 _4diMdqhH7k"
};
const $a962904bbde7c9a2$var$SelectToEditButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate } = t0;
    const [t1, t2] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId } = t1;
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = t2;
    let t3;
    if ($[0] !== cardId || $[1] !== extensionLocalId || $[2] !== selectedExtensionLocalId || $[3] !== setIsInAutoFocusMode || $[4] !== setSelectedToEditCardId) {
        t3 = ()=>{
            if (cardId && extensionLocalId === selectedExtensionLocalId) {
                setIsInAutoFocusMode(true);
                setSelectedToEditCardId(cardId);
            }
        };
        $[0] = cardId;
        $[1] = extensionLocalId;
        $[2] = selectedExtensionLocalId;
        $[3] = setIsInAutoFocusMode;
        $[4] = setSelectedToEditCardId;
        $[5] = t3;
    } else t3 = $[5];
    const handleClick = t3;
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    let t4;
    let t5;
    if ($[6] !== isSelectedToEdit || $[7] !== isSelectedToRemove || $[8] !== onSelectStateUpdate) {
        t4 = ()=>{
            onSelectStateUpdate?.({
                isSelectedToEdit: isSelectedToEdit,
                isSelectedToRemove: isSelectedToRemove
            });
        };
        t5 = [
            isSelectedToEdit,
            isSelectedToRemove,
            onSelectStateUpdate
        ];
        $[6] = isSelectedToEdit;
        $[7] = isSelectedToRemove;
        $[8] = onSelectStateUpdate;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.overlayButtonForSelectToEdit
        ]);
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0589719409b932c8$export$2e2bcd8739ae039).selectToEditAriaLabel));
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== handleClick) {
        t8 = /*#__PURE__*/ $cozmU.createElement("button", {
            onClick: handleClick,
            className: t6
        }, t7);
        $[13] = handleClick;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (cardId && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(cardId);
        }
    }, [
        cardId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    (0, $cozmU.useEffect)(()=>{
        onSelectStateUpdate?.({
            isSelectedToEdit: isSelectedToEdit,
            isSelectedToRemove: isSelectedToRemove
        });
    }, [
        isSelectedToEdit,
        isSelectedToRemove,
        onSelectStateUpdate
    ]); /*
                                                                   	Overlay an invisible button to allow click interaction on edit.
                                                                   	Also avoid violating A11y rules for making non-interactive element interactive by putting onClick on the container.
                                                                   */ 
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    return /*#__PURE__*/ $cozmU.createElement("button", {
        onClick: handleClick,
        className: (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.overlayButtonForSelectToEdit
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0589719409b932c8$export$2e2bcd8739ae039).selectToEditAriaLabel)));
}; /**
    *
    * This component is used to wrap the card content and set the followings of the card
    * - border
    * - height (optional)
    * - background color
    * - hover effect ( for view)
    * - outline (for edit)
    * - color
    */ 
const $a962904bbde7c9a2$export$8a23e74e5cf3ca41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: t1, enableHubCornerRadius: t2, cornerRadiusOverride: cornerRadiusOverride } = t0;
    const isHoverable = t1 === undefined ? true : t1;
    const enableHubCornerRadius = t2 === undefined ? false : t2;
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $cozmU.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $cozmU.useState)(false);
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    let t3;
    if ($[0] !== getDarkModeCompatibleTextColor || $[1] !== savedTextColor) {
        t3 = savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined;
        $[0] = getDarkModeCompatibleTextColor;
        $[1] = savedTextColor;
        $[2] = t3;
    } else t3 = $[2];
    const textColor = t3;
    let t4;
    if ($[3] !== getDarkModeCompatibleBackgroundColor || $[4] !== savedBackgroundColor) {
        t4 = savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined;
        $[3] = getDarkModeCompatibleBackgroundColor;
        $[4] = savedBackgroundColor;
        $[5] = t4;
    } else t4 = $[5];
    const backgroundColor = t4;
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $37e5cd8620e57bb3$export$1b6000962053a12c)(backgroundColor);
    let t5;
    if ($[6] !== handleHover) {
        t5 = ()=>{
            handleHover();
        };
        $[6] = handleHover;
        $[7] = t5;
    } else t5 = $[7];
    const handleMouseEnter = t5;
    let t6;
    if ($[8] !== handleUnhover) {
        t6 = ()=>{
            handleUnhover();
        };
        $[8] = handleUnhover;
        $[9] = t6;
    } else t6 = $[9];
    const handleMouseLeave = t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (t8)=>{
            const { isSelectedToEdit: isSelectedToEdit_0, isSelectedToRemove: isSelectedToRemove_0 } = t8;
            setIsSelectedToEdit(isSelectedToEdit_0);
            setIsSelectedToRemove(isSelectedToRemove_0);
        };
        $[10] = t7;
    } else t7 = $[10];
    const handleSelectStateUpdate = t7;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const isHubCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const useHubRadius = enableHubCornerRadius && isHubCornerRadiusEnabled;
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    let t8;
    if ($[11] !== cornerRadiusOverride || $[12] !== isCornerRadiusLocked || $[13] !== useHubRadius) {
        t8 = useHubRadius ? {
            borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            ...!isCornerRadiusLocked && typeof cornerRadiusOverride === "number" ? {
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
            } : {}
        } : {};
        $[11] = cornerRadiusOverride;
        $[12] = isCornerRadiusLocked;
        $[13] = useHubRadius;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== borderColor || $[16] !== cardHeight || $[17] !== currentBackgroundColor || $[18] !== t8 || $[19] !== textColor) {
        t9 = {
            height: cardHeight,
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor,
            ...t8
        };
        $[15] = borderColor;
        $[16] = cardHeight;
        $[17] = currentBackgroundColor;
        $[18] = t8;
        $[19] = textColor;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== handleMouseEnter || $[22] !== handleMouseLeave || $[23] !== isCardHoverable || $[24] !== savedBackgroundColor) {
        t10 = isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {};
        $[21] = handleMouseEnter;
        $[22] = handleMouseLeave;
        $[23] = isCardHoverable;
        $[24] = savedBackgroundColor;
        $[25] = t10;
    } else t10 = $[25];
    const t11 = !useHubRadius && !hideCorner && $a962904bbde7c9a2$var$unboundedStyles.containerCorner;
    const t12 = isCardHoverable && $a962904bbde7c9a2$var$unboundedStyles.viewOnHover;
    const t13 = isSelectedToEdit && $a962904bbde7c9a2$var$unboundedStyles.selectedToEdit;
    const t14 = isSelectedToRemove && $a962904bbde7c9a2$var$unboundedStyles.selectedToRemove;
    let t15;
    if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14) {
        t15 = (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.containerBaseUpdated,
            t11,
            t12,
            t13,
            t14
        ]);
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
    } else t15 = $[30];
    let t16;
    if ($[31] !== cardId || $[32] !== extensionLocalId || $[33] !== isCardEditable) {
        t16 = isCardEditable && /*#__PURE__*/ $cozmU.createElement($a962904bbde7c9a2$var$SelectToEditButton, {
            onSelectStateUpdate: handleSelectStateUpdate,
            cardId: cardId,
            extensionLocalId: extensionLocalId
        });
        $[31] = cardId;
        $[32] = extensionLocalId;
        $[33] = isCardEditable;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== children || $[36] !== id || $[37] !== t10 || $[38] !== t15 || $[39] !== t16 || $[40] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": id,
            style: t9,
            ...t10,
            className: t15
        }, t16, children);
        $[35] = children;
        $[36] = id;
        $[37] = t10;
        $[38] = t15;
        $[39] = t16;
        $[40] = t9;
        $[41] = t17;
    } else t17 = $[41];
    return t17;
} : ({ id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: isHoverable = true, enableHubCornerRadius: enableHubCornerRadius = false, cornerRadiusOverride: cornerRadiusOverride })=>{
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $cozmU.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $cozmU.useState)(false); // handle theme responsiveness for text and background colors
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = (0, $cozmU.useMemo)(()=>savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined, [
        savedTextColor,
        getDarkModeCompatibleTextColor
    ]);
    const backgroundColor = (0, $cozmU.useMemo)(()=>savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined, [
        savedBackgroundColor,
        getDarkModeCompatibleBackgroundColor
    ]);
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $37e5cd8620e57bb3$export$1b6000962053a12c)(backgroundColor);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        handleHover();
    }, [
        handleHover
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        handleUnhover();
    }, [
        handleUnhover
    ]); // handle select to edit
    const handleSelectStateUpdate = (0, $cozmU.useCallback)(({ isSelectedToEdit: isSelectedToEdit_0, isSelectedToRemove: isSelectedToRemove_0 })=>{
        setIsSelectedToEdit(isSelectedToEdit_0);
        setIsSelectedToRemove(isSelectedToRemove_0);
    }, [
        setIsSelectedToEdit,
        setIsSelectedToRemove
    ]);
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const isHubCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const useHubRadius = enableHubCornerRadius && isHubCornerRadiusEnabled; // Per-element corner radius is Premium. The value lives in the ADF, so a
    // downgrade cannot clear it — ignoring the override here makes the element
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": id,
        style: {
            height: cardHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            ...useHubRadius ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {}
        },
        ...isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {},
        className: (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.containerBaseUpdated,
            !useHubRadius && !hideCorner && $a962904bbde7c9a2$var$unboundedStyles.containerCorner,
            isCardHoverable && $a962904bbde7c9a2$var$unboundedStyles.viewOnHover,
            isSelectedToEdit && $a962904bbde7c9a2$var$unboundedStyles.selectedToEdit,
            isSelectedToRemove && $a962904bbde7c9a2$var$unboundedStyles.selectedToRemove
        ])
    }, isCardEditable && /*#__PURE__*/ $cozmU.createElement($a962904bbde7c9a2$var$SelectToEditButton, {
        onSelectStateUpdate: handleSelectStateUpdate,
        cardId: cardId,
        extensionLocalId: extensionLocalId
    }), children);
};















const $7671493751624151$export$9e87ed1f12141293 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardId, link, onCardSucceeded, onCardFailed)=>{
    const $ = (0, $bDgLe.c)(21);
    const [isResolved, setIsResolved] = (0, $cozmU.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $cozmU.useState)("");
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $cozmU.useRef)(false);
    const isRestricted = errorCardStatus === "forbidden";
    const isUnauthorized = errorCardStatus === "unauthorized";
    const isNoResult = errorCardStatus === "not_found";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            setErrorCardStatus("");
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== link) {
        t1 = [
            link,
            setErrorCardStatus
        ];
        $[1] = link;
        $[2] = t1;
    } else t1 = $[2];
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== onCardFailed || $[4] !== submitError) {
        t2 = (err)=>{
            onCardFailed(err);
            submitError?.(err);
        };
        $[3] = onCardFailed;
        $[4] = submitError;
        $[5] = t2;
    } else t2 = $[5];
    const failExperienceAndSendErrorMonitoring = t2;
    let t3;
    if ($[6] !== cardId || $[7] !== failExperienceAndSendErrorMonitoring || $[8] !== onCardSucceeded) {
        t3 = (t4)=>{
            const { status: status, err: err_0 } = t4;
            setErrorCardStatus(status);
            setIsResolved(true);
            if (status === "unauthorized") shouldPreserveErrorStatus.current = true;
            if (err_0) failExperienceAndSendErrorMonitoring(err_0);
            else onCardSucceeded(cardId);
        };
        $[6] = cardId;
        $[7] = failExperienceAndSendErrorMonitoring;
        $[8] = onCardSucceeded;
        $[9] = t3;
    } else t3 = $[9];
    const trackAndCategorizeError = t3;
    let t4;
    if ($[10] !== cardId || $[11] !== onCardSucceeded) {
        t4 = ()=>{
            onCardSucceeded(cardId);
            setIsResolved(true);
            if (shouldPreserveErrorStatus.current) {
                shouldPreserveErrorStatus.current = false;
                return;
            }
            setErrorCardStatus("");
        };
        $[10] = cardId;
        $[11] = onCardSucceeded;
        $[12] = t4;
    } else t4 = $[12];
    const trackSuccess = t4;
    let t5;
    if ($[13] !== errorCardStatus || $[14] !== isNoResult || $[15] !== isResolved || $[16] !== isRestricted || $[17] !== isUnauthorized || $[18] !== trackAndCategorizeError || $[19] !== trackSuccess) {
        t5 = {
            isNoResult: isNoResult,
            isRestricted: isRestricted,
            isUnauthorized: isUnauthorized,
            errorCardStatus: errorCardStatus,
            isResolved: isResolved,
            trackAndCategorizeError: trackAndCategorizeError,
            trackSuccess: trackSuccess
        };
        $[13] = errorCardStatus;
        $[14] = isNoResult;
        $[15] = isResolved;
        $[16] = isRestricted;
        $[17] = isUnauthorized;
        $[18] = trackAndCategorizeError;
        $[19] = trackSuccess;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [isResolved, setIsResolved] = (0, $cozmU.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $cozmU.useState)('');
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $cozmU.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $cozmU.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $cozmU.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $cozmU.useCallback)(({ status: status, err: err_0 })=>{
        setErrorCardStatus(status);
        setIsResolved(true);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err_0) failExperienceAndSendErrorMonitoring(err_0);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $cozmU.useCallback)(()=>{
        onCardSucceeded(cardId);
        setIsResolved(true);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        isResolved: isResolved,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};






var $iMYjN = parcelRequire("iMYjN");

var $dhLnb = parcelRequire("dhLnb");








var $3s2S5 = parcelRequire("3s2S5");

const $37d9cdf0819e0905$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $37d9cdf0819e0905$export$71956575015d1f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $37d9cdf0819e0905$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $37d9cdf0819e0905$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? "";
    return "";
} : (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $37d9cdf0819e0905$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $37d9cdf0819e0905$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};











const $56bdef66f01f9e9c$export$28a088c1679c6579 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown } = t0;
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $cozmU.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $cozmU.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $cozmU.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $cozmU.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $cozmU.useState)();
    let t1;
    let t2;
    if ($[0] !== isModifiedOnShown || $[1] !== isOwnerInfoShown || $[2] !== isSocialStatsShown) {
        t1 = ()=>{
            setIsAvatarAvailable(!!isOwnerInfoShown);
            setIsOwnerNameAvailable(!!isOwnerInfoShown);
            setIsModifiedOnAvailable(!!isModifiedOnShown);
            setIsCommentCountAvailable(!!isSocialStatsShown);
            setIsReactCountAvailable(!!isSocialStatsShown);
        };
        t2 = [
            isOwnerInfoShown,
            isModifiedOnShown,
            isSocialStatsShown
        ];
        $[0] = isModifiedOnShown;
        $[1] = isOwnerInfoShown;
        $[2] = isSocialStatsShown;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const shouldRenderOwnerInfo = isAvatarAvailable || isOwnerNameAvailable;
    const shouldRenderMetadata = shouldRenderOwnerInfo || isModifiedOnAvailable;
    const shouldRenderSocials = isReactCountAvailable || isCommentCountAvailable;
    let t3;
    if ($[5] !== shouldRenderMetadata || $[6] !== shouldRenderOwnerInfo || $[7] !== shouldRenderSocials) {
        t3 = {
            setIsAvatarAvailable: setIsAvatarAvailable,
            setIsOwnerNameAvailable: setIsOwnerNameAvailable,
            setIsModifiedOnAvailable: setIsModifiedOnAvailable,
            setIsReactCountAvailable: setIsReactCountAvailable,
            setIsCommentCountAvailable: setIsCommentCountAvailable,
            shouldRenderOwnerInfo: shouldRenderOwnerInfo,
            shouldRenderMetadata: shouldRenderMetadata,
            shouldRenderSocials: shouldRenderSocials
        };
        $[5] = shouldRenderMetadata;
        $[6] = shouldRenderOwnerInfo;
        $[7] = shouldRenderSocials;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown })=>{
    // smart card elements render states
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $cozmU.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $cozmU.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $cozmU.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $cozmU.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        // attempt to render the elements when they are supposed to be shown to get data availability
        setIsAvatarAvailable(!!isOwnerInfoShown);
        setIsOwnerNameAvailable(!!isOwnerInfoShown);
        setIsModifiedOnAvailable(!!isModifiedOnShown);
        setIsCommentCountAvailable(!!isSocialStatsShown);
        setIsReactCountAvailable(!!isSocialStatsShown);
    }, [
        isOwnerInfoShown,
        isModifiedOnShown,
        isSocialStatsShown
    ]);
    const shouldRenderOwnerInfo = (0, $cozmU.useMemo)(()=>isAvatarAvailable || isOwnerNameAvailable, [
        isAvatarAvailable,
        isOwnerNameAvailable
    ]);
    const shouldRenderMetadata = (0, $cozmU.useMemo)(()=>shouldRenderOwnerInfo || isModifiedOnAvailable, [
        shouldRenderOwnerInfo,
        isModifiedOnAvailable
    ]);
    const shouldRenderSocials = (0, $cozmU.useMemo)(()=>isReactCountAvailable || isCommentCountAvailable, [
        isReactCountAvailable,
        isCommentCountAvailable
    ]);
    return {
        setIsAvatarAvailable: setIsAvatarAvailable,
        setIsOwnerNameAvailable: setIsOwnerNameAvailable,
        setIsModifiedOnAvailable: setIsModifiedOnAvailable,
        setIsReactCountAvailable: setIsReactCountAvailable,
        setIsCommentCountAvailable: setIsCommentCountAvailable,
        shouldRenderOwnerInfo: shouldRenderOwnerInfo,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    };
};












var $epZ7a = parcelRequire("epZ7a");














var $4wH3g = parcelRequire("4wH3g");


var $iLpJO = parcelRequire("iLpJO");


const $617759dfffa61af2$export$836160481278e63f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vUDoI",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("esAkB"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ $cozmU.createElement((0, $iLpJO.EmojiPlaceholder), props) : null
});
const $617759dfffa61af2$var$styles = {
    wrapper: "_3iDTPbQ4SZ _37wbyuDIqT"
};
const $617759dfffa61af2$export$56e4c85b6a8d02e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { emojiId: emojiId, height: t1, width: t2 } = t0;
    const height = t1 === undefined ? 40 : t1;
    const width = t2 === undefined ? 40 : t2;
    let t3;
    if ($[0] !== width) {
        t3 = (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $hekY6.default)([
                    $617759dfffa61af2$var$styles.wrapper
                ])
            });
        $[0] = width;
        $[1] = t3;
    } else t3 = $[1];
    const wrapper = t3;
    if (!emojiId) return null;
    let t4;
    if ($[2] !== emojiId || $[3] !== height || $[4] !== wrapper) {
        t4 = /*#__PURE__*/ $cozmU.createElement($617759dfffa61af2$export$836160481278e63f, {
            emoji: emojiId,
            height: height,
            wrapper: wrapper,
            renderResourcedEmoji: true
        });
        $[2] = emojiId;
        $[3] = height;
        $[4] = wrapper;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ emojiId: emojiId, height: height = 40, width: width = 40 })=>{
    const wrapper = (0, $cozmU.useMemo)(()=>(props)=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $hekY6.default)([
                    $617759dfffa61af2$var$styles.wrapper
                ])
            }), [
        width
    ]);
    if (!emojiId) return null;
    return /*#__PURE__*/ $cozmU.createElement($617759dfffa61af2$export$836160481278e63f, {
        emoji: emojiId,
        height: height,
        wrapper: wrapper,
        renderResourcedEmoji: true
    });
};





var $4yccB = parcelRequire("4yccB");




const $f6e7599786666e93$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $f6e7599786666e93$export$6ed6867e3290476 = (link)=>{
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const [emojiId, setEmojiId] = (0, $cozmU.useState)();
    const getEmoji = (0, $cozmU.useCallback)(async ()=>{
        const client = new (0, $4yccB.default)();
        try {
            const queriedEmojiObject = await client.fetchData(link);
            setEmojiId($f6e7599786666e93$var$sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
        } catch (error) {
            submitError?.(error);
        }
    }, [
        link,
        submitError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!!link) getEmoji();
    }, [
        link,
        getEmoji
    ]);
    return {
        emojiId: !!emojiId ? emojiId : null
    };
};


const $7f30d41a2009de7e$export$69387b41dfc808f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { link: link } = t0;
    const { emojiId: emojiId } = (0, $f6e7599786666e93$export$6ed6867e3290476)(link);
    let t1;
    if ($[0] !== emojiId) {
        t1 = emojiId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617759dfffa61af2$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined;
        $[0] = emojiId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epZ7a.LinkIconElement), {
            iconTileSize: 24,
            render: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ link: link })=>{
    const { emojiId: emojiId } = (0, $f6e7599786666e93$export$6ed6867e3290476)(link);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epZ7a.LinkIconElement), {
        iconTileSize: 24,
        render: emojiId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617759dfffa61af2$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined
    });
};














var $68e47287a83f3aa2$export$6eeb615c261d1c6b = /*#__PURE__*/ function(FontVariant) {
    FontVariant["HeadingMedium"] = "headingMedium";
    FontVariant["HeadingSmall"] = "headingSmall";
    FontVariant["HeadingXSmall"] = "headingXSmall";
    FontVariant["Body"] = "body";
    FontVariant["BodyLarge"] = "bodyLarge";
    return FontVariant;
}({});
const $68e47287a83f3aa2$var$unboundedStyles = {
    baseText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54R7LI7",
    title: "_39xV02N91d",
    description: "_1ANEUSzUZr",
    headingMedium: "_2sNsIgWSk4",
    headingSmall: "_2sNsIg1kXk",
    headingXSmall: "_2sNsIgEqul",
    bodyLarge: "_2sNsIg20Hp",
    body: "_2sNsIgmnOE"
};
const $68e47287a83f3aa2$export$474db65c3c394e1c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, maxLine: maxLine, fontVariant: fontVariant } = t0;
    let t1;
    if ($[0] !== maxLine) {
        t1 = {
            WebkitLineClamp: maxLine
        };
        $[0] = maxLine;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = $68e47287a83f3aa2$var$unboundedStyles[fontVariant];
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.title,
            t2
        ]);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t1 || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            style: t1,
            className: t3
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.title,
            $68e47287a83f3aa2$var$unboundedStyles[fontVariant]
        ])
    }, children);
const $68e47287a83f3aa2$export$16e0ed4cb97c00d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, maxLine: maxLine, fontVariant: fontVariant } = t0;
    let t1;
    if ($[0] !== maxLine) {
        t1 = {
            WebkitLineClamp: maxLine
        };
        $[0] = maxLine;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = $68e47287a83f3aa2$var$unboundedStyles[fontVariant];
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.description,
            t2
        ]);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t1 || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            style: t1,
            className: t3
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.description,
            $68e47287a83f3aa2$var$unboundedStyles[fontVariant]
        ])
    }, children);





const $0295777f01fea73a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $166f78176fd22bef$var$unboundedStyles = {
    avatar: "_0NUa3roWWg _3138428e2l _3O9OjOdnbC _1I4qEadnbC _1sF9FQdnbC _41l4Z3dnbC _2VfTfadnbC _3TbW4OdnbC _1U2ZlkdnbC _37HH87dnbC _1YfSqRdnbC _07Yl1RdnbC _1OKaLLdnbC _1tnTmpdnbC",
    snippetOverride: "_1UtDYzOLYo _0memvT20Hp _1tggGzOLYo",
    smartCardWrapper: "_0jFU0VN91d _28Yf51N91d"
};
const $166f78176fd22bef$var$styles = {
    content: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    imageCorner: "_0bjKvD8fU6",
    imageWithPadding: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VWD6W",
    imageNoPadding: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VgZxp _313842UgYP _0adFHsUgYP _2XsHFMUgYP _1wydGW1Y8M",
    headerWithImagePadding: "_0Of8r22ADO _2Zuz6Q2ADO",
    headerWithImage: "_3iDTPbQ4SZ _1mT5xdWVPG _2IhTon5zaO _3OE6xY5zaO",
    unresolvedAction: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg20Hp _39xV02N91d _39HuIbz8Lp _1UtDYzZpcK",
    static: "_1mT5xd5HSx",
    relative: "_1mT5xdRAKS"
};
const $166f78176fd22bef$var$MIN_TITLE_LINES = 3;
const $166f78176fd22bef$var$MAX_TITLE_LINES = 5;
const $166f78176fd22bef$var$MIN_DESCRIPTION_LINES = 3;
const $166f78176fd22bef$var$MAX_DESCRIPTION_LINES = 6;
const $166f78176fd22bef$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $166f78176fd22bef$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $166f78176fd22bef$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 2;
        descriptionMaxLine += 3;
    }
    if (titleMaxLine > $166f78176fd22bef$var$MAX_TITLE_LINES) titleMaxLine = $166f78176fd22bef$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $166f78176fd22bef$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $166f78176fd22bef$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $166f78176fd22bef$export$a59c193ce67944a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription } = t0;
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $166f78176fd22bef$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: $166f78176fd22bef$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $0295777f01fea73a$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const T0 = (0, $iMnC5.Box);
    const t6 = "large-card-v2-content";
    const t7 = hasLink ? $166f78176fd22bef$var$styles.static : $166f78176fd22bef$var$styles.relative;
    let t8;
    if ($[8] !== t7) {
        t8 = (0, $w6R6I.cx)($166f78176fd22bef$var$styles.content, t7);
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== cardMaxHeight || $[11] !== cardMinHeight) {
        t9 = {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        };
        $[10] = cardMaxHeight;
        $[11] = cardMinHeight;
        $[12] = t9;
    } else t9 = $[12];
    const T1 = (0, $dinVW.Stack);
    const t10 = "space-between";
    const t11 = "space.200";
    const t12 = "fill";
    const T2 = (0, $dinVW.Stack);
    const t13 = "space.200";
    const t14 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "large-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $166f78176fd22bef$var$styles.imageWithPadding : $166f78176fd22bef$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $166f78176fd22bef$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? isPaddingEnabled ? {
            borderRadius: `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)`
        } : {
            borderTopLeftRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            borderTopRightRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    }));
    const t15 = (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $166f78176fd22bef$var$styles.headerWithImage, hasImage && isPaddingEnabled && $166f78176fd22bef$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    }));
    let t16;
    if ($[13] !== cardBodyItems) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "large-card-body",
            space: "space.100"
        }, cardBodyItems);
        $[13] = cardBodyItems;
        $[14] = t16;
    } else t16 = $[14];
    let t17;
    if ($[15] !== T2 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement(T2, {
            space: t13
        }, t14, t15, t16);
        $[15] = T2;
        $[16] = t14;
        $[17] = t15;
        $[18] = t16;
        $[19] = t17;
    } else t17 = $[19];
    let t18;
    if ($[20] !== hasError || $[21] !== hasLink || $[22] !== isPublishDateShown || $[23] !== isResolved || $[24] !== setIsAvatarAvailable || $[25] !== setIsCommentCountAvailable || $[26] !== setIsModifiedOnAvailable || $[27] !== setIsOwnerNameAvailable || $[28] !== setIsReactCountAvailable || $[29] !== shouldRenderMetadata || $[30] !== shouldRenderOwnerInfo || $[31] !== shouldRenderSocials) {
        t18 = hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        })));
        $[20] = hasError;
        $[21] = hasLink;
        $[22] = isPublishDateShown;
        $[23] = isResolved;
        $[24] = setIsAvatarAvailable;
        $[25] = setIsCommentCountAvailable;
        $[26] = setIsModifiedOnAvailable;
        $[27] = setIsOwnerNameAvailable;
        $[28] = setIsReactCountAvailable;
        $[29] = shouldRenderMetadata;
        $[30] = shouldRenderOwnerInfo;
        $[31] = shouldRenderSocials;
        $[32] = t18;
    } else t18 = $[32];
    let t19;
    if ($[33] !== T1 || $[34] !== t17 || $[35] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement(T1, {
            spread: t10,
            space: t11,
            grow: t12
        }, t17, t18);
        $[33] = T1;
        $[34] = t17;
        $[35] = t18;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== T0 || $[38] !== t19 || $[39] !== t8 || $[40] !== t9) {
        t20 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t6,
            xcss: t8,
            style: t9
        }, t19);
        $[37] = T0;
        $[38] = t19;
        $[39] = t8;
        $[40] = t9;
        $[41] = t20;
    } else t20 = $[41];
    const cardContent = t20;
    let t21;
    if ($[42] !== cardContent || $[43] !== cardId || $[44] !== enableSnippetRenderer || $[45] !== hasLink || $[46] !== isInViewMode || $[47] !== link || $[48] !== trackAndCategorizeError || $[49] !== trackSuccess) {
        t21 = hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.smartCardWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent)) : cardContent;
        $[42] = cardContent;
        $[43] = cardId;
        $[44] = enableSnippetRenderer;
        $[45] = hasLink;
        $[46] = isInViewMode;
        $[47] = link;
        $[48] = trackAndCategorizeError;
        $[49] = trackSuccess;
        $[50] = t21;
    } else t21 = $[50];
    let t22;
    if ($[51] !== backgroundColor || $[52] !== borderColor || $[53] !== cardId || $[54] !== cornerRadiusOverride || $[55] !== cornerStyle || $[56] !== extensionLocalId || $[57] !== hasLink || $[58] !== isInViewMode || $[59] !== isManualVariant || $[60] !== t21 || $[61] !== textColor) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "large-card-v2-container",
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride
        }, t21);
        $[51] = backgroundColor;
        $[52] = borderColor;
        $[53] = cardId;
        $[54] = cornerRadiusOverride;
        $[55] = cornerStyle;
        $[56] = extensionLocalId;
        $[57] = hasLink;
        $[58] = isInViewMode;
        $[59] = isManualVariant;
        $[60] = t21;
        $[61] = textColor;
        $[62] = t22;
    } else t22 = $[62];
    return t22;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc); // Author can hide images on Help Hub dynamic cards; suppress the resolved
    // image so the card reflows to its no-image layout.
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $166f78176fd22bef$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: $166f78176fd22bef$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $0295777f01fea73a$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "large-card-v2-content",
        xcss: (0, $w6R6I.cx)($166f78176fd22bef$var$styles.content, hasLink ? $166f78176fd22bef$var$styles.static : $166f78176fd22bef$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        spread: "space-between",
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "large-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $166f78176fd22bef$var$styles.imageWithPadding : $166f78176fd22bef$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $166f78176fd22bef$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? isPaddingEnabled ? {
            // Padded image is inset from every card edge, so round all corners.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)`
        } : {
            // No-padding image is flush with the card's top / left / right
            // edges, but its bottom meets the card body — round only the top
            // corners so the bottom stays square (matches design).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderTopLeftRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderTopRightRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $166f78176fd22bef$var$styles.headerWithImage, hasImage && isPaddingEnabled && $166f78176fd22bef$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "large-card-body",
        space: "space.100"
    }, cardBodyItems)), hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
        alignBlock: "center"
    }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $166f78176fd22bef$var$unboundedStyles.avatar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
        onRender: setIsAvatarAvailable
    })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
        color: "inherit",
        hideFormat: true,
        onRender: setIsOwnerNameAvailable
    })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
        color: "inherit",
        hideDatePrefix: true,
        onRender: setIsModifiedOnAvailable
    })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
        color: "inherit",
        onRender: setIsReactCountAvailable
    }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
        color: "inherit",
        onRender: setIsCommentCountAvailable
    })))));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "large-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $166f78176fd22bef$var$unboundedStyles.smartCardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Large,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent)) : cardContent);
};

































































const $5e28c8f1464f076b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $dabbc9a27c7fab5d$var$unboundedStyles = {
    avatar: "_0NUa3roWWg _313842Vo9d _3O9OjOdnbC _1I4qEadnbC _1sF9FQdnbC _41l4Z3dnbC _2VfTfadnbC _3TbW4OdnbC _1U2ZlkdnbC _37HH87dnbC _1YfSqRdnbC _07Yl1RdnbC _1OKaLLdnbC _1tnTmpdnbC",
    snippetOverride: "_1UtDYzOLYo _0memvT20Hp _1tggGzOLYo"
};
const $dabbc9a27c7fab5d$var$styles = {
    content: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    image: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _0jFU0VN91d",
    floatingIcon: "_4bt5LAYvD1 _2WAcuGYvD1 _0LQT5E5zaO _2IhTonB0rP _0jFU0VdnbC _1mT5xdRAKS",
    body: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    socials: "_313842IZbP",
    unresolvedAction: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg20Hp _39xV02N91d _39HuIbz8Lp _1UtDYzZpcK"
};
const $dabbc9a27c7fab5d$var$MIN_TITLE_LINES = 2;
const $dabbc9a27c7fab5d$var$MAX_TITLE_LINES = 4;
const $dabbc9a27c7fab5d$var$MIN_DESCRIPTION_LINES = 3;
const $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES = 6;
const $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $dabbc9a27c7fab5d$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $dabbc9a27c7fab5d$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 1;
        if (!shouldRenderMetadata) {
            titleMaxLine += 1;
            descriptionMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $dabbc9a27c7fab5d$var$MAX_TITLE_LINES) titleMaxLine = $dabbc9a27c7fab5d$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $dabbc9a27c7fab5d$export$299421c7aa71f32d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer } = t0;
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    let t6;
    if ($[8] !== description || $[9] !== descriptionMaxLine || $[10] !== enableSnippetRenderer || $[11] !== formatMessage || $[12] !== hasError || $[13] !== hasImage || $[14] !== hasLink || $[15] !== isIconShown || $[16] !== isPublishDateShown || $[17] !== isResolved || $[18] !== link || $[19] !== setIsAvatarAvailable || $[20] !== setIsCommentCountAvailable || $[21] !== setIsModifiedOnAvailable || $[22] !== setIsOwnerNameAvailable || $[23] !== setIsReactCountAvailable || $[24] !== shouldRenderMetadata || $[25] !== shouldRenderOwnerInfo || $[26] !== shouldRenderSocials || $[27] !== showDescription || $[28] !== title || $[29] !== titleMaxLine) {
        t6 = hasLink ? [
            isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
                key: "link-icon",
                link: link
            }),
            title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
            }, title),
            hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                key: "unresolved-action",
                xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.unresolvedAction)
            }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
            isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                testId: "large-card-v1-metadata",
                key: "metadata",
                space: "space.050",
                separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
                alignBlock: "center"
            }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $dabbc9a27c7fab5d$var$unboundedStyles.avatar
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                onRender: setIsAvatarAvailable
            })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
                color: "inherit",
                hideFormat: true,
                onRender: setIsOwnerNameAvailable
            })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                color: "inherit",
                onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
            })),
            showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
                key: "snippet",
                className: (0, $hekY6.default)([
                    $dabbc9a27c7fab5d$var$unboundedStyles.snippetOverride
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })),
            showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
            }, description),
            isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                testId: "large-card-v1-socials",
                key: "socials",
                space: "space.150",
                xcss: $dabbc9a27c7fab5d$var$styles.socials
            }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
                color: "inherit",
                onRender: setIsReactCountAvailable
            }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
                color: "inherit",
                onRender: setIsCommentCountAvailable
            }))
        ].filter(Boolean) : [
            /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
            }, title || formatMessage((0, $5e28c8f1464f076b$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
            description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
            }, description)
        ].filter(Boolean);
        $[8] = description;
        $[9] = descriptionMaxLine;
        $[10] = enableSnippetRenderer;
        $[11] = formatMessage;
        $[12] = hasError;
        $[13] = hasImage;
        $[14] = hasLink;
        $[15] = isIconShown;
        $[16] = isPublishDateShown;
        $[17] = isResolved;
        $[18] = link;
        $[19] = setIsAvatarAvailable;
        $[20] = setIsCommentCountAvailable;
        $[21] = setIsModifiedOnAvailable;
        $[22] = setIsOwnerNameAvailable;
        $[23] = setIsReactCountAvailable;
        $[24] = shouldRenderMetadata;
        $[25] = shouldRenderOwnerInfo;
        $[26] = shouldRenderSocials;
        $[27] = showDescription;
        $[28] = title;
        $[29] = titleMaxLine;
        $[30] = t6;
    } else t6 = $[30];
    const cardBodyItems = t6;
    let t7;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.content);
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== cardHeight) {
        t8 = {
            height: cardHeight
        };
        $[32] = cardHeight;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== contentId || $[35] !== displayImageSrc || $[36] !== hasImage || $[37] !== hasLink || $[38] !== imageAltText) {
        t9 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        $[34] = contentId;
        $[35] = displayImageSrc;
        $[36] = hasImage;
        $[37] = hasLink;
        $[38] = imageAltText;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== hasImage || $[41] !== hasLink || $[42] !== isIconShown || $[43] !== link) {
        t10 = isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.floatingIcon)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            link: link
        }));
        $[40] = hasImage;
        $[41] = hasLink;
        $[42] = isIconShown;
        $[43] = link;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.body);
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== cardBodyItems) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "large-card-body",
            space: "space.100",
            grow: "fill",
            xcss: t11
        }, cardBodyItems);
        $[46] = cardBodyItems;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== t10 || $[49] !== t12 || $[50] !== t8 || $[51] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "large-card-content",
            xcss: t7,
            style: t8
        }, t9, t10, t12);
        $[48] = t10;
        $[49] = t12;
        $[50] = t8;
        $[51] = t9;
        $[52] = t13;
    } else t13 = $[52];
    const cardContent = t13;
    let t14;
    if ($[53] !== cardContent || $[54] !== cardId || $[55] !== enableSnippetRenderer || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== link || $[59] !== trackAndCategorizeError || $[60] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).XLarge,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[53] = cardContent;
        $[54] = cardId;
        $[55] = enableSnippetRenderer;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = link;
        $[59] = trackAndCategorizeError;
        $[60] = trackSuccess;
        $[61] = t14;
    } else t14 = $[61];
    let t15;
    if ($[62] !== backgroundColor || $[63] !== cardHeight || $[64] !== cardId || $[65] !== cornerRadiusOverride || $[66] !== cornerStyle || $[67] !== extensionLocalId || $[68] !== hasLink || $[69] !== isInViewMode || $[70] !== isManualVariant || $[71] !== t14 || $[72] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "large-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[62] = backgroundColor;
        $[63] = cardHeight;
        $[64] = cardId;
        $[65] = cornerRadiusOverride;
        $[66] = cornerStyle;
        $[67] = extensionLocalId;
        $[68] = hasLink;
        $[69] = isInViewMode;
        $[70] = isManualVariant;
        $[71] = t14;
        $[72] = textColor;
        $[73] = t15;
    } else t15 = $[73];
    return t15;
} : ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc); // Author can hide images on Help Hub dynamic cards; suppress the resolved
    // image so the card reflows to its no-image layout.
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            key: "link-icon",
            link: link
        }),
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "large-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dabbc9a27c7fab5d$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
        })),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $dabbc9a27c7fab5d$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "large-card-v1-socials",
            key: "socials",
            space: "space.150",
            xcss: $dabbc9a27c7fab5d$var$styles.socials
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        }))
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $5e28c8f1464f076b$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "large-card-content",
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.content),
        style: {
            height: cardHeight
        }
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.floatingIcon)
    }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "large-card-body",
        space: "space.100",
        grow: "fill",
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.body)
    }, cardBodyItems));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "large-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).XLarge,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};

































































const $7f5a4eebb6cb4a95$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $47140f834e4043e2$var$unboundedStyles = {
    avatar: "_0NUa3roWWg _3O9OjOdnbC _1I4qEadnbC _1sF9FQdnbC _41l4Z3dnbC _2VfTfadnbC _3TbW4OdnbC _1U2ZlkdnbC _37HH87dnbC _1YfSqRdnbC _07Yl1RdnbC _1OKaLLdnbC _1tnTmpdnbC",
    snippetOverride: "_1UtDYzOLYo _0memvTmnOE _1tggGzOLYo",
    smartCardWrapper: "_0jFU0VN91d _28Yf51N91d"
};
const $47140f834e4043e2$var$styles = {
    content: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    imageCorner: "_0bjKvD8fU6",
    imageWithPadding: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VqjqO",
    imageNoPadding: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VVazu _313842UgYP _0adFHsUgYP _2XsHFMUgYP",
    headerWithImagePadding: "_0Of8r22ADO _2Zuz6Q2ADO",
    headerWithImage: "_3iDTPbQ4SZ _1mT5xdWVPG _2IhTon5zaO _3OE6xY5zaO",
    unresolvedAction: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39xV02N91d _39HuIbz8Lp _1UtDYzZpcK",
    static: "_1mT5xd5HSx",
    relative: "_1mT5xdRAKS"
};
const $47140f834e4043e2$var$MIN_TITLE_LINES = 3;
const $47140f834e4043e2$var$MIN_DESCRIPTION_LINES = 3;
const $47140f834e4043e2$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $47140f834e4043e2$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $47140f834e4043e2$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 2;
    }
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $47140f834e4043e2$export$b38e9910221b4e7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription } = t0;
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $47140f834e4043e2$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: $47140f834e4043e2$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $7f5a4eebb6cb4a95$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const T0 = (0, $iMnC5.Box);
    const t6 = "medium-card-v2-content";
    const t7 = hasLink ? $47140f834e4043e2$var$styles.static : $47140f834e4043e2$var$styles.relative;
    let t8;
    if ($[8] !== t7) {
        t8 = (0, $w6R6I.cx)($47140f834e4043e2$var$styles.content, t7);
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== cardMaxHeight || $[11] !== cardMinHeight) {
        t9 = {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        };
        $[10] = cardMaxHeight;
        $[11] = cardMinHeight;
        $[12] = t9;
    } else t9 = $[12];
    const T1 = (0, $dinVW.Stack);
    const t10 = "space-between";
    const t11 = "space.150";
    const t12 = "fill";
    const T2 = (0, $dinVW.Stack);
    const t13 = "space.150";
    const t14 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "medium-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $47140f834e4043e2$var$styles.imageWithPadding : $47140f834e4043e2$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $47140f834e4043e2$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? isPaddingEnabled ? {
            borderRadius: `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)`
        } : {
            borderTopLeftRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            borderTopRightRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    }));
    const t15 = (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $47140f834e4043e2$var$styles.headerWithImage, hasImage && isPaddingEnabled && $47140f834e4043e2$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    }));
    let t16;
    if ($[13] !== cardBodyItems) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "medium-card-body",
            space: "space.100"
        }, cardBodyItems);
        $[13] = cardBodyItems;
        $[14] = t16;
    } else t16 = $[14];
    let t17;
    if ($[15] !== T2 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement(T2, {
            space: t13
        }, t14, t15, t16);
        $[15] = T2;
        $[16] = t14;
        $[17] = t15;
        $[18] = t16;
        $[19] = t17;
    } else t17 = $[19];
    let t18;
    if ($[20] !== hasError || $[21] !== hasLink || $[22] !== isPublishDateShown || $[23] !== isResolved || $[24] !== setIsAvatarAvailable || $[25] !== setIsCommentCountAvailable || $[26] !== setIsModifiedOnAvailable || $[27] !== setIsReactCountAvailable || $[28] !== shouldRenderMetadata || $[29] !== shouldRenderOwnerInfo || $[30] !== shouldRenderSocials) {
        t18 = hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        })));
        $[20] = hasError;
        $[21] = hasLink;
        $[22] = isPublishDateShown;
        $[23] = isResolved;
        $[24] = setIsAvatarAvailable;
        $[25] = setIsCommentCountAvailable;
        $[26] = setIsModifiedOnAvailable;
        $[27] = setIsReactCountAvailable;
        $[28] = shouldRenderMetadata;
        $[29] = shouldRenderOwnerInfo;
        $[30] = shouldRenderSocials;
        $[31] = t18;
    } else t18 = $[31];
    let t19;
    if ($[32] !== T1 || $[33] !== t17 || $[34] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement(T1, {
            spread: t10,
            space: t11,
            grow: t12
        }, t17, t18);
        $[32] = T1;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== T0 || $[37] !== t19 || $[38] !== t8 || $[39] !== t9) {
        t20 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t6,
            xcss: t8,
            style: t9
        }, t19);
        $[36] = T0;
        $[37] = t19;
        $[38] = t8;
        $[39] = t9;
        $[40] = t20;
    } else t20 = $[40];
    const cardContent = t20;
    let t21;
    if ($[41] !== cardContent || $[42] !== cardId || $[43] !== enableSnippetRenderer || $[44] !== hasLink || $[45] !== isInViewMode || $[46] !== link || $[47] !== trackAndCategorizeError || $[48] !== trackSuccess) {
        t21 = hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.smartCardWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent)) : cardContent;
        $[41] = cardContent;
        $[42] = cardId;
        $[43] = enableSnippetRenderer;
        $[44] = hasLink;
        $[45] = isInViewMode;
        $[46] = link;
        $[47] = trackAndCategorizeError;
        $[48] = trackSuccess;
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== backgroundColor || $[51] !== borderColor || $[52] !== cardId || $[53] !== cornerRadiusOverride || $[54] !== cornerStyle || $[55] !== extensionLocalId || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== isManualVariant || $[59] !== t21 || $[60] !== textColor) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "medium-card-v2-container",
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride
        }, t21);
        $[50] = backgroundColor;
        $[51] = borderColor;
        $[52] = cardId;
        $[53] = cornerRadiusOverride;
        $[54] = cornerStyle;
        $[55] = extensionLocalId;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = isManualVariant;
        $[59] = t21;
        $[60] = textColor;
        $[61] = t22;
    } else t22 = $[61];
    return t22;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc); // Author can hide images on Help Hub dynamic cards; suppress the resolved
    // image so the card reflows to its no-image layout.
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $47140f834e4043e2$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: $47140f834e4043e2$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Description
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $7f5a4eebb6cb4a95$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "medium-card-v2-content",
        xcss: (0, $w6R6I.cx)($47140f834e4043e2$var$styles.content, hasLink ? $47140f834e4043e2$var$styles.static : $47140f834e4043e2$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        spread: "space-between",
        space: "space.150",
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "medium-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $47140f834e4043e2$var$styles.imageWithPadding : $47140f834e4043e2$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $47140f834e4043e2$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? isPaddingEnabled ? {
            // Padded image is inset from every card edge, so round all corners.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)`
        } : {
            // No-padding image is flush with the card's top / left / right
            // edges, but its bottom meets the card body — round only the top
            // corners so the bottom stays square (matches design).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderTopLeftRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderTopRightRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $47140f834e4043e2$var$styles.headerWithImage, hasImage && isPaddingEnabled && $47140f834e4043e2$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "medium-card-body",
        space: "space.100"
    }, cardBodyItems)), hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $47140f834e4043e2$var$unboundedStyles.avatar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
        onRender: setIsAvatarAvailable
    })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
        color: "inherit",
        hideDatePrefix: true,
        onRender: setIsModifiedOnAvailable
    })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
        color: "inherit",
        onRender: setIsReactCountAvailable
    }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
        color: "inherit",
        onRender: setIsCommentCountAvailable
    })))));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "medium-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $47140f834e4043e2$var$unboundedStyles.smartCardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent)) : cardContent);
};

































































const $442c4fd68a480cb2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $3f1cee5e0d0614d4$var$unboundedStyles = {
    avatar: "_0NUa3roWWg _313842Vo9d _3O9OjOdnbC _1I4qEadnbC _1sF9FQdnbC _41l4Z3dnbC _2VfTfadnbC _3TbW4OdnbC _1U2ZlkdnbC _37HH87dnbC _1YfSqRdnbC _07Yl1RdnbC _1OKaLLdnbC _1tnTmpdnbC",
    snippetOverride: "_1UtDYzOLYo _0memvTmnOE _1tggGzOLYo"
};
const $3f1cee5e0d0614d4$var$styles = {
    content: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    image: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _0jFU0VN91d",
    floatingIcon: "_4bt5LAYvD1 _2WAcuGYvD1 _0LQT5E5zaO _2IhTonB0rP _0jFU0VdnbC _1mT5xdRAKS",
    body: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    socials: "_313842IZbP",
    unresolvedAction: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39xV02N91d _39HuIbz8Lp _1UtDYzZpcK"
};
const $3f1cee5e0d0614d4$var$MIN_TITLE_LINES = 2;
const $3f1cee5e0d0614d4$var$MAX_TITLE_LINES = 5;
const $3f1cee5e0d0614d4$var$MIN_DESCRIPTION_LINES = 3;
const $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES = 7;
const $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $3f1cee5e0d0614d4$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $3f1cee5e0d0614d4$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        descriptionMaxLine += 2;
        titleMaxLine += 2;
        if (!shouldRenderMetadata) {
            descriptionMaxLine += 1;
            titleMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $3f1cee5e0d0614d4$var$MAX_TITLE_LINES) titleMaxLine = $3f1cee5e0d0614d4$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $3f1cee5e0d0614d4$export$42440eb4dfc95ce7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = t0;
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    let t6;
    if ($[8] !== description || $[9] !== descriptionMaxLine || $[10] !== enableSnippetRenderer || $[11] !== formatMessage || $[12] !== hasError || $[13] !== hasImage || $[14] !== hasLink || $[15] !== isIconShown || $[16] !== isPublishDateShown || $[17] !== isResolved || $[18] !== link || $[19] !== setIsAvatarAvailable || $[20] !== setIsCommentCountAvailable || $[21] !== setIsModifiedOnAvailable || $[22] !== setIsOwnerNameAvailable || $[23] !== setIsReactCountAvailable || $[24] !== shouldRenderMetadata || $[25] !== shouldRenderOwnerInfo || $[26] !== shouldRenderSocials || $[27] !== showDescription || $[28] !== title || $[29] !== titleMaxLine) {
        t6 = hasLink ? [
            isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
                key: "link-icon",
                link: link
            }),
            title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
            }, title),
            hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                key: "unresolved-action",
                xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.unresolvedAction)
            }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
            isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                testId: "medium-card-v1-metadata",
                key: "metadata",
                space: "space.050",
                separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
                alignBlock: "center"
            }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $3f1cee5e0d0614d4$var$unboundedStyles.avatar
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                onRender: setIsAvatarAvailable
            })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
                color: "inherit",
                hideFormat: true,
                onRender: setIsOwnerNameAvailable
            })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                color: "inherit",
                hideDatePrefix: true,
                onRender: setIsModifiedOnAvailable
            })),
            showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
                key: "snippet",
                className: (0, $hekY6.default)([
                    $3f1cee5e0d0614d4$var$unboundedStyles.snippetOverride
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })),
            showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
            }, description),
            isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                testId: "medium-card-v1-socials",
                key: "socials",
                space: "space.150",
                xcss: $3f1cee5e0d0614d4$var$styles.socials
            }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
                color: "inherit",
                onRender: setIsReactCountAvailable
            }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
                color: "inherit",
                onRender: setIsCommentCountAvailable
            }))
        ].filter(Boolean) : [
            /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
            }, title || formatMessage((0, $442c4fd68a480cb2$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
            description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
            }, description)
        ].filter(Boolean);
        $[8] = description;
        $[9] = descriptionMaxLine;
        $[10] = enableSnippetRenderer;
        $[11] = formatMessage;
        $[12] = hasError;
        $[13] = hasImage;
        $[14] = hasLink;
        $[15] = isIconShown;
        $[16] = isPublishDateShown;
        $[17] = isResolved;
        $[18] = link;
        $[19] = setIsAvatarAvailable;
        $[20] = setIsCommentCountAvailable;
        $[21] = setIsModifiedOnAvailable;
        $[22] = setIsOwnerNameAvailable;
        $[23] = setIsReactCountAvailable;
        $[24] = shouldRenderMetadata;
        $[25] = shouldRenderOwnerInfo;
        $[26] = shouldRenderSocials;
        $[27] = showDescription;
        $[28] = title;
        $[29] = titleMaxLine;
        $[30] = t6;
    } else t6 = $[30];
    const cardBodyItems = t6;
    let t7;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.content);
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== cardHeight) {
        t8 = {
            height: cardHeight
        };
        $[32] = cardHeight;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== contentId || $[35] !== displayImageSrc || $[36] !== hasImage || $[37] !== hasLink || $[38] !== imageAltText) {
        t9 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        $[34] = contentId;
        $[35] = displayImageSrc;
        $[36] = hasImage;
        $[37] = hasLink;
        $[38] = imageAltText;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== hasImage || $[41] !== hasLink || $[42] !== isIconShown || $[43] !== link) {
        t10 = isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.floatingIcon)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            link: link
        }));
        $[40] = hasImage;
        $[41] = hasLink;
        $[42] = isIconShown;
        $[43] = link;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.body);
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== cardBodyItems) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "medium-card-body",
            space: "space.100",
            grow: "fill",
            xcss: t11
        }, cardBodyItems);
        $[46] = cardBodyItems;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== t10 || $[49] !== t12 || $[50] !== t8 || $[51] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "medium-card-v1-content",
            xcss: t7,
            style: t8
        }, t9, t10, t12);
        $[48] = t10;
        $[49] = t12;
        $[50] = t8;
        $[51] = t9;
        $[52] = t13;
    } else t13 = $[52];
    const cardContent = t13;
    let t14;
    if ($[53] !== cardContent || $[54] !== cardId || $[55] !== enableSnippetRenderer || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== link || $[59] !== trackAndCategorizeError || $[60] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[53] = cardContent;
        $[54] = cardId;
        $[55] = enableSnippetRenderer;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = link;
        $[59] = trackAndCategorizeError;
        $[60] = trackSuccess;
        $[61] = t14;
    } else t14 = $[61];
    let t15;
    if ($[62] !== backgroundColor || $[63] !== cardHeight || $[64] !== cardId || $[65] !== cornerRadiusOverride || $[66] !== cornerStyle || $[67] !== extensionLocalId || $[68] !== hasLink || $[69] !== isInViewMode || $[70] !== isManualVariant || $[71] !== t14 || $[72] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "medium-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[62] = backgroundColor;
        $[63] = cardHeight;
        $[64] = cardId;
        $[65] = cornerRadiusOverride;
        $[66] = cornerStyle;
        $[67] = extensionLocalId;
        $[68] = hasLink;
        $[69] = isInViewMode;
        $[70] = isManualVariant;
        $[71] = t14;
        $[72] = textColor;
        $[73] = t15;
    } else t15 = $[73];
    return t15;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc); // Author can hide images on Help Hub dynamic cards; suppress the resolved
    // image so the card reflows to its no-image layout.
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            key: "link-icon",
            link: link
        }),
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "medium-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $3f1cee5e0d0614d4$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $3f1cee5e0d0614d4$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "medium-card-v1-socials",
            key: "socials",
            space: "space.150",
            xcss: $3f1cee5e0d0614d4$var$styles.socials
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        }))
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $442c4fd68a480cb2$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "medium-card-v1-content",
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.content),
        style: {
            height: cardHeight
        }
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.floatingIcon)
    }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "medium-card-body",
        space: "space.100",
        grow: "fill",
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.body)
    }, cardBodyItems));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "medium-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};
























































const $31e75c2dfb5de843$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $ddb6d1b8eae6067e$var$unboundedStyles = {
    content: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNL7p2s",
    avatar: "_0NUa3roWWg _313842Vo9d _3O9OjOdnbC _1I4qEadnbC _1sF9FQdnbC _41l4Z3dnbC _2VfTfadnbC _3TbW4OdnbC _1U2ZlkdnbC _37HH87dnbC _1YfSqRdnbC _07Yl1RdnbC _1OKaLLdnbC _1tnTmpdnbC"
};
const $ddb6d1b8eae6067e$var$styles = {
    body: "_4bt5LAnQyn _2WAcuGnQyn _0Of8r22ADO _1wydGW2ADO _0jFU0VN91d",
    bodyWithImage: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _2Zuz6Q2ADO _1Znuxb2ADO _1EqgXlo8ts _3iDTPbQ4SZ",
    bodyWithoutImage: "_2Zuz6Q5zaO _1Znuxb5zaO",
    image: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEL3iR _0jFU0VN91d _1EqgXlL3iR _3iDTPbQ4SZ",
    unresolvedAction: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39xV02N91d _39HuIbz8Lp _1UtDYzZpcK"
};
const $ddb6d1b8eae6067e$export$5c35843a47cb7bc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(77);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isImageShown: isImageShown, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t4);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    let T0;
    let cardBodyItem;
    let t10;
    let t11;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== cardHeight || $[8] !== contentId || $[9] !== displayImageSrc || $[10] !== formatMessage || $[11] !== hasError || $[12] !== hasLink || $[13] !== imageAltText || $[14] !== isImageShown || $[15] !== isPublishDateShown || $[16] !== isResolved || $[17] !== setIsAvatarAvailable || $[18] !== setIsModifiedOnAvailable || $[19] !== shouldRenderMetadata || $[20] !== shouldRenderOwnerInfo || $[21] !== title) {
        const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
            imageSrc: displayImageSrc
        });
        const hasImage = isImageShown !== false && resolvedHasImage;
        let t12;
        if ($[31] !== formatMessage || $[32] !== hasError || $[33] !== hasLink || $[34] !== isPublishDateShown || $[35] !== isResolved || $[36] !== setIsAvatarAvailable || $[37] !== setIsModifiedOnAvailable || $[38] !== shouldRenderMetadata || $[39] !== shouldRenderOwnerInfo || $[40] !== title) {
            t12 = hasLink ? [
                title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                    key: "title",
                    maxLine: shouldRenderMetadata ? 2 : 3,
                    fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
                }, title),
                hasError && !title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    key: "unresolved-action",
                    xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.unresolvedAction)
                }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
                isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    testId: "small-card-v1-metadata",
                    key: "metadata",
                    space: "space.050",
                    alignBlock: "center"
                }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $ddb6d1b8eae6067e$var$unboundedStyles.avatar
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                    onRender: setIsAvatarAvailable
                })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                    color: "inherit",
                    onRender: setIsModifiedOnAvailable
                }))
            ].filter(Boolean) : [
                /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                    key: "title",
                    maxLine: 3,
                    fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
                }, title || formatMessage((0, $31e75c2dfb5de843$export$defe85febe8b728c).emptyStatePlaceholderTitle))
            ].filter(Boolean);
            $[31] = formatMessage;
            $[32] = hasError;
            $[33] = hasLink;
            $[34] = isPublishDateShown;
            $[35] = isResolved;
            $[36] = setIsAvatarAvailable;
            $[37] = setIsModifiedOnAvailable;
            $[38] = shouldRenderMetadata;
            $[39] = shouldRenderOwnerInfo;
            $[40] = title;
            $[41] = t12;
        } else t12 = $[41];
        cardBodyItem = t12;
        t8 = "small-card-content";
        if ($[42] !== cardHeight) {
            t9 = {
                height: cardHeight
            };
            $[42] = cardHeight;
            $[43] = t9;
        } else t9 = $[43];
        if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $hekY6.default)([
                $ddb6d1b8eae6067e$var$unboundedStyles.content
            ]);
            $[44] = t10;
        } else t10 = $[44];
        t11 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        T0 = (0, $dinVW.Stack);
        t5 = "small-card-body";
        t6 = "space.100";
        t7 = (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.body, hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithImage, !hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithoutImage);
        $[7] = cardHeight;
        $[8] = contentId;
        $[9] = displayImageSrc;
        $[10] = formatMessage;
        $[11] = hasError;
        $[12] = hasLink;
        $[13] = imageAltText;
        $[14] = isImageShown;
        $[15] = isPublishDateShown;
        $[16] = isResolved;
        $[17] = setIsAvatarAvailable;
        $[18] = setIsModifiedOnAvailable;
        $[19] = shouldRenderMetadata;
        $[20] = shouldRenderOwnerInfo;
        $[21] = title;
        $[22] = T0;
        $[23] = cardBodyItem;
        $[24] = t10;
        $[25] = t11;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else {
        T0 = $[22];
        cardBodyItem = $[23];
        t10 = $[24];
        t11 = $[25];
        t5 = $[26];
        t6 = $[27];
        t7 = $[28];
        t8 = $[29];
        t9 = $[30];
    }
    let t12;
    if ($[45] !== T0 || $[46] !== cardBodyItem || $[47] !== t5 || $[48] !== t6 || $[49] !== t7) {
        t12 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t5,
            space: t6,
            xcss: t7,
            alignBlock: "center",
            alignInline: "start"
        }, cardBodyItem);
        $[45] = T0;
        $[46] = cardBodyItem;
        $[47] = t5;
        $[48] = t6;
        $[49] = t7;
        $[50] = t12;
    } else t12 = $[50];
    let t13;
    if ($[51] !== t10 || $[52] !== t11 || $[53] !== t12 || $[54] !== t8 || $[55] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t8,
            style: t9,
            className: t10
        }, t11, t12);
        $[51] = t10;
        $[52] = t11;
        $[53] = t12;
        $[54] = t8;
        $[55] = t9;
        $[56] = t13;
    } else t13 = $[56];
    const cardContent = t13;
    let t14;
    if ($[57] !== cardContent || $[58] !== cardId || $[59] !== hasLink || $[60] !== isInViewMode || $[61] !== link || $[62] !== trackAndCategorizeError || $[63] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[57] = cardContent;
        $[58] = cardId;
        $[59] = hasLink;
        $[60] = isInViewMode;
        $[61] = link;
        $[62] = trackAndCategorizeError;
        $[63] = trackSuccess;
        $[64] = t14;
    } else t14 = $[64];
    let t15;
    if ($[65] !== backgroundColor || $[66] !== cardHeight || $[67] !== cardId || $[68] !== cornerRadiusOverride || $[69] !== cornerStyle || $[70] !== extensionLocalId || $[71] !== hasLink || $[72] !== isInViewMode || $[73] !== isManualVariant || $[74] !== t14 || $[75] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "small-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[65] = backgroundColor;
        $[66] = cardHeight;
        $[67] = cardId;
        $[68] = cornerRadiusOverride;
        $[69] = cornerStyle;
        $[70] = extensionLocalId;
        $[71] = hasLink;
        $[72] = isInViewMode;
        $[73] = isManualVariant;
        $[74] = t14;
        $[75] = textColor;
        $[76] = t15;
    } else t15 = $[76];
    return t15;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isImageShown: isImageShown, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $7671493751624151$export$9e87ed1f12141293)(cardId, link, onCardSucceeded, onCardFailed);
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc); // Author can hide images on Help Hub dynamic cards; suppress the resolved
    // image so the card reflows to its no-image layout.
    const { hasImage: resolvedHasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const hasImage = isImageShown !== false && resolvedHasImage;
    const cardBodyItem = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: shouldRenderMetadata ? 2 : 3,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
        }, title),
        hasError && !title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "small-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $ddb6d1b8eae6067e$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            onRender: setIsModifiedOnAvailable
        }))
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: 3,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
        }, title || formatMessage((0, $31e75c2dfb5de843$export$defe85febe8b728c).emptyStatePlaceholderTitle))
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "small-card-content",
        style: {
            height: cardHeight
        },
        className: (0, $hekY6.default)([
            $ddb6d1b8eae6067e$var$unboundedStyles.content
        ])
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "small-card-body",
        space: "space.100",
        xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.body, hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithImage, !hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithoutImage),
        alignBlock: "center",
        alignInline: "start"
    }, cardBodyItem));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "small-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Large,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};


















var $cJ0FD = parcelRequire("cJ0FD");







var $2cd66bff04bdca7b$exports = {};
$2cd66bff04bdca7b$exports = new URL("General.d0402e27.svg", import.meta.url).toString();


var $8ngiY = parcelRequire("8ngiY");









const $185c8639eab033dc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResultsTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-results-title",
        defaultMessage: "Nothing yet. Check back soon."
    },
    noFilterTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-filter-title",
        defaultMessage: "Add filters to populate cards."
    }
});


const $7ba972e52fd00d2a$var$styles = {
    container: "_0jFU0VN91d",
    imageBase: "_0KLXrumhAQ",
    imageFlexibleHeight: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4kiQYAdnbC",
    imageFixedHeightMedium: "_0jFU0VVazu",
    imageFixedHeightLarge: "_0jFU0VgZxp",
    innerImageSmall: "_39xV02fI2J _0jFU0VfI2J _0Of8r21Y8M _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q1Y8M",
    titleBase: "_2sNsIgmnOE _1Znuxb8HPE _2Zuz6Q8HPE _0Of8r28HPE _1wydGW8HPE _1UtDYzy7kJ",
    largeFont: "_2sNsIg20Hp",
    titleBlock: "_0jFU0VpJKa",
    imageInline: "_4ouGXIljYU _0jFU0VN91d",
    titleInline: "_0jFU0VN91d"
};
const $7ba972e52fd00d2a$var$SmallCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { imageSrc: imageSrc, title: title } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, $7ba972e52fd00d2a$var$styles.imageInline);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== imageSrc) {
        t2 = imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $7ba972e52fd00d2a$var$styles.innerImageSmall
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: imageSrc,
            alt: "no-result",
            testId: "no-result-image"
        }));
        $[1] = imageSrc;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t1
        }, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleInline);
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== title) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            xcss: t4
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title));
        $[6] = title;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t3 || $[9] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "no-result-card-small",
            xcss: $7ba972e52fd00d2a$var$styles.container
        }, t3, t5);
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ imageSrc: imageSrc, title: title })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "no-result-card-small",
        xcss: $7ba972e52fd00d2a$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, $7ba972e52fd00d2a$var$styles.imageInline)
    }, imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $7ba972e52fd00d2a$var$styles.innerImageSmall
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: imageSrc,
        alt: "no-result",
        testId: "no-result-image"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleInline)
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title)));
};
const $7ba972e52fd00d2a$var$MediumLargeCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isImageFixedHeight: isImageFixedHeight, cardSize: t1, imageSrc: imageSrc, title: title } = t0;
    const cardSize = t1 === undefined ? (0, $hjUDQ.Height).MEDIUM : t1;
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    const t2 = isImageFixedHeight ? isLargeCard ? $7ba972e52fd00d2a$var$styles.imageFixedHeightLarge : $7ba972e52fd00d2a$var$styles.imageFixedHeightMedium : $7ba972e52fd00d2a$var$styles.imageFlexibleHeight;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== imageSrc) {
        t4 = imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: imageSrc,
            alt: "no-result",
            testId: "no-result-image"
        });
        $[2] = imageSrc;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t3
        }, t4);
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = isLargeCard && $7ba972e52fd00d2a$var$styles.largeFont;
    let t7;
    if ($[7] !== t6) {
        t7 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleBlock, t6);
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== title) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title);
        $[9] = title;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t7
        }, t8);
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t5 || $[15] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "no-result-card",
            space: "space.025",
            xcss: $7ba972e52fd00d2a$var$styles.container
        }, t5, t9);
        $[14] = t5;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize = (0, $hjUDQ.Height).MEDIUM, imageSrc: imageSrc, title: title })=>{
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "no-result-card",
        space: "space.025",
        xcss: $7ba972e52fd00d2a$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, isImageFixedHeight ? isLargeCard ? $7ba972e52fd00d2a$var$styles.imageFixedHeightLarge : $7ba972e52fd00d2a$var$styles.imageFixedHeightMedium : $7ba972e52fd00d2a$var$styles.imageFlexibleHeight)
    }, imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: imageSrc,
        alt: "no-result",
        testId: "no-result-image"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleBlock, isLargeCard && $7ba972e52fd00d2a$var$styles.largeFont)
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title)));
};
var $7ba972e52fd00d2a$export$fddf379e22a74b00 = /*#__PURE__*/ function(EmptyState) {
    EmptyState["NO_FILTER"] = "noFilter";
    EmptyState["NO_RESULTS"] = "noResults";
    return EmptyState;
}({});
const $7ba972e52fd00d2a$var$getStateContent = (state)=>{
    if (state === "noFilter") return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8ngiY))),
        title: (0, $185c8639eab033dc$export$defe85febe8b728c).noFilterTitle
    };
    return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($2cd66bff04bdca7b$exports))),
        title: (0, $185c8639eab033dc$export$defe85febe8b728c).noResultsTitle
    };
};
const $7ba972e52fd00d2a$export$15b55049a5f7f585 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state } = t0;
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    let t1;
    if ($[0] !== state) {
        t1 = $7ba972e52fd00d2a$var$getStateContent(state);
        $[0] = state;
        $[1] = t1;
    } else t1 = $[1];
    const { imageSrc: imageSrc, title: title } = t1;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) {
        let t2;
        if ($[2] !== maxHeight || $[3] !== minHeight) {
            t2 = {
                minHeight: minHeight,
                maxHeight: maxHeight
            };
            $[2] = maxHeight;
            $[3] = minHeight;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== cardSize || $[6] !== imageSrc || $[7] !== title) {
            t3 = /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
                isImageFixedHeight: true,
                cardSize: cardSize,
                imageSrc: imageSrc,
                title: title
            });
            $[5] = cardSize;
            $[6] = imageSrc;
            $[7] = title;
            $[8] = t3;
        } else t3 = $[8];
        let t4;
        if ($[9] !== t2 || $[10] !== t3) {
            t4 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), null, /*#__PURE__*/ $cozmU.createElement("div", {
                style: t2
            }, t3));
            $[9] = t2;
            $[10] = t3;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    let t2;
    if ($[12] !== cardSize || $[13] !== imageSrc || $[14] !== title) {
        t2 = cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$SmallCard, {
            imageSrc: imageSrc,
            title: title
        }) : /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
            imageSrc: imageSrc,
            title: title
        });
        $[12] = cardSize;
        $[13] = imageSrc;
        $[14] = title;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== height || $[17] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            cardHeight: height
        }, t2);
        $[16] = height;
        $[17] = t2;
        $[18] = t3;
    } else t3 = $[18];
    return t3;
} : ({ cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const { imageSrc: imageSrc, title: title } = $7ba972e52fd00d2a$var$getStateContent(state);
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), null, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            minHeight: minHeight,
            maxHeight: maxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
        isImageFixedHeight: true,
        cardSize: cardSize,
        imageSrc: imageSrc,
        title: title
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        cardHeight: height
    }, cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$SmallCard, {
        imageSrc: imageSrc,
        title: title
    }) : /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
        imageSrc: imageSrc,
        title: title
    }));
};

















var $4ez2K = parcelRequire("4ez2K");









const $ddecac981a5dbce2$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $ddecac981a5dbce2$var$styles = {
    content: "_0jFU0VN91d",
    image: "_0KLXrumhAQ",
    imageFixedHeightMedium: "_0jFU0VVazu",
    imageFixedHeightLarge: "_0jFU0VgZxp",
    imageFlexibleHeight: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4kiQYAdnbC",
    imageSmall: "_4ouGXIL3iR",
    body: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    bodySmall: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    itemCommon: "_0jFU0VJg58 _0KLXrumhAQ",
    title: "_39xV02rIqH",
    publishedDate: "_39xV02N91d",
    descriptionFirstLine: "_39xV02E0OO",
    descriptionSecondLine: "_39xV02Mzbf",
    titleLarge: "_39xV02HMkp",
    descriptionFirstLineLarge: "_39xV02gZxp",
    descriptionSecondLineLarge: "_39xV02ehCh"
};
const $ddecac981a5dbce2$var$ContentSmall = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, $ddecac981a5dbce2$var$styles.imageSmall)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.body, $ddecac981a5dbce2$var$styles.bodySmall);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.title)
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: $ddecac981a5dbce2$var$styles.content
        }, t0, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050",
            xcss: t1,
            alignBlock: "center"
        }, t2, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
        })));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $ddecac981a5dbce2$var$styles.content
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, $ddecac981a5dbce2$var$styles.imageSmall)
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.body, $ddecac981a5dbce2$var$styles.bodySmall),
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.title)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
    })));
const $ddecac981a5dbce2$var$Content = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { isImageFixedHeight: isImageFixedHeight, cardSize: cardSize } = t0;
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    const t1 = isImageFixedHeight ? isLargeCard ? $ddecac981a5dbce2$var$styles.imageFixedHeightLarge : $ddecac981a5dbce2$var$styles.imageFixedHeightMedium : $ddecac981a5dbce2$var$styles.imageFlexibleHeight;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = isLargeCard ? $ddecac981a5dbce2$var$styles.titleLarge : $ddecac981a5dbce2$var$styles.title;
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t4);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t5
        });
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
        });
        $[8] = t7;
    } else t7 = $[8];
    const t8 = isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionFirstLineLarge : $ddecac981a5dbce2$var$styles.descriptionFirstLine;
    let t9;
    if ($[9] !== t8) {
        t9 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t8);
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t9
        });
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    const t11 = isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionSecondLineLarge : $ddecac981a5dbce2$var$styles.descriptionSecondLine;
    let t12;
    if ($[13] !== t11) {
        t12 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t11);
        $[13] = t11;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t12
        });
        $[15] = t12;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] !== t10 || $[18] !== t13 || $[19] !== t6) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.075",
            xcss: $ddecac981a5dbce2$var$styles.body
        }, t6, t7, t10, t13);
        $[17] = t10;
        $[18] = t13;
        $[19] = t6;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== t14 || $[22] !== t3) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $ddecac981a5dbce2$var$styles.content
        }, t3, t14);
        $[21] = t14;
        $[22] = t3;
        $[23] = t15;
    } else t15 = $[23];
    return t15;
} : ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize })=>{
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: $ddecac981a5dbce2$var$styles.content
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, isImageFixedHeight ? isLargeCard ? $ddecac981a5dbce2$var$styles.imageFixedHeightLarge : $ddecac981a5dbce2$var$styles.imageFixedHeightMedium : $ddecac981a5dbce2$var$styles.imageFlexibleHeight)
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.075",
        xcss: $ddecac981a5dbce2$var$styles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.titleLarge : $ddecac981a5dbce2$var$styles.title)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionFirstLineLarge : $ddecac981a5dbce2$var$styles.descriptionFirstLine)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionSecondLineLarge : $ddecac981a5dbce2$var$styles.descriptionSecondLine)
    })));
};
const $ddecac981a5dbce2$export$f67f215fe23c6b24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { cardDimensions: cardDimensions, cardSize: cardSize, layout: layout } = t0;
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) {
        const t1 = `${containerId}-v2`;
        let t2;
        if ($[0] !== maxHeight || $[1] !== minHeight) {
            t2 = {
                minHeight: minHeight,
                maxHeight: maxHeight
            };
            $[0] = maxHeight;
            $[1] = minHeight;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== cardSize) {
            t3 = /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
                isImageFixedHeight: true,
                cardSize: cardSize
            });
            $[3] = cardSize;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== t2 || $[6] !== t3) {
            t4 = /*#__PURE__*/ $cozmU.createElement("div", {
                style: t2
            }, t3);
            $[5] = t2;
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== t1 || $[9] !== t4) {
            t5 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
                id: t1
            }, t4);
            $[8] = t1;
            $[9] = t4;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    }
    const t1 = `${containerId}-v1`;
    let t2;
    if ($[11] !== cardSize) {
        t2 = cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$ContentSmall, null) : /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
            cardSize: cardSize
        });
        $[11] = cardSize;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== height || $[14] !== t1 || $[15] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: t1,
            cardHeight: height
        }, t2);
        $[13] = height;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ cardDimensions: cardDimensions, cardSize: cardSize, layout: layout })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v2`
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            minHeight: minHeight,
            maxHeight: maxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
        isImageFixedHeight: true,
        cardSize: cardSize
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v1`,
        cardHeight: height
    }, cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$ContentSmall, null) : /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
        cardSize: cardSize
    }));
};





















var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");










const $a33e106b66cb0e0f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    previous: {
        id: "company-hub.cards-extension.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "company-hub.cards-extension.row-orientation.next",
        defaultMessage: "Next"
    }
});


const $7583eda5bec7c437$var$styles = {
    footer: "_37wbyuI7V3 _0hPCNLDIqT _0Of8r2gVvo",
    footerNav: "_2mHwu81Y8M _2XsHFMIZbP",
    iconBackgroundColor: "_0bjKvDS5Zs _0KLXruoI2d"
};
const $7583eda5bec7c437$export$d1f75a226e49cd83 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext } = t0;
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    const t1 = isStacked && !showAIDisclaimer && $7583eda5bec7c437$var$styles.footerNav;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($7583eda5bec7c437$var$styles.footer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== showAIDisclaimer) {
        t3 = showAIDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null);
        $[2] = showAIDisclaimer;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== allCardsShown || $[5] !== isAtBeginning || $[6] !== isAtEnd || $[7] !== isStacked || $[8] !== scrollToNext || $[9] !== scrollToPrevious) {
        t4 = !isStacked && !allCardsShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $7583eda5bec7c437$var$styles.footerNav
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            isDisabled: isAtBeginning,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).previous),
            onClick: scrollToPrevious
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            isDisabled: isAtEnd,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).next),
            onClick: scrollToNext
        })));
        $[4] = allCardsShown;
        $[5] = isAtBeginning;
        $[6] = isAtEnd;
        $[7] = isStacked;
        $[8] = scrollToNext;
        $[9] = scrollToPrevious;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            testId: "link-cards-content-cards-row-navigation",
            xcss: t2
        }, t3, t4);
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext })=>{
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        testId: "link-cards-content-cards-row-navigation",
        xcss: (0, $w6R6I.cx)($7583eda5bec7c437$var$styles.footer, isStacked && !showAIDisclaimer && $7583eda5bec7c437$var$styles.footerNav)
    }, showAIDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null), !isStacked && !allCardsShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $7583eda5bec7c437$var$styles.footerNav
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        isDisabled: isAtBeginning,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).previous),
        onClick: scrollToPrevious
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        isDisabled: isAtEnd,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).next),
        onClick: scrollToNext
    }))));
};


const $acbc23a21ff09bf1$var$styles = {
    cardWrapper: "_0jFU0VN91d"
};
const $acbc23a21ff09bf1$var$CARD_SIZE_FLEXIBLE_MAP = {
    [(0, $hjUDQ.Height).SMALL]: (0, $ddb6d1b8eae6067e$export$5c35843a47cb7bc4),
    [(0, $hjUDQ.Height).MEDIUM]: (0, $3f1cee5e0d0614d4$export$42440eb4dfc95ce7),
    [(0, $hjUDQ.Height).LARGE]: (0, $dabbc9a27c7fab5d$export$299421c7aa71f32d)
};
const $acbc23a21ff09bf1$var$CARD_SIZE_FIXED_MAP = {
    [(0, $hjUDQ.Height).SMALL]: (0, $ddb6d1b8eae6067e$export$5c35843a47cb7bc4),
    [(0, $hjUDQ.Height).MEDIUM]: (0, $47140f834e4043e2$export$b38e9910221b4e7e),
    [(0, $hjUDQ.Height).LARGE]: (0, $166f78176fd22bef$export$a59c193ce67944a7)
};
const $acbc23a21ff09bf1$var$getCardComponent = (cardSize, layout)=>{
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return $acbc23a21ff09bf1$var$CARD_SIZE_FIXED_MAP[cardSize] ?? (0, $47140f834e4043e2$export$b38e9910221b4e7e);
     // Default to flexible cards (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return $acbc23a21ff09bf1$var$CARD_SIZE_FLEXIBLE_MAP[cardSize] ?? (0, $3f1cee5e0d0614d4$export$42440eb4dfc95ce7);
};
const $acbc23a21ff09bf1$export$bab15f92b6d84cb6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId } = t0;
    const validatedCardParams = (0, $f73aa100a9fdb106$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC;
    let t1;
    if ($[0] !== layout || $[1] !== size) {
        t1 = (0, $7ee74d072d6273e0$export$90cc9ab68d35b5b9)({
            cardSize: size,
            layout: layout
        });
        $[0] = layout;
        $[1] = size;
        $[2] = t1;
    } else t1 = $[2];
    const cardDimensions = t1;
    let t2;
    if ($[3] !== layout || $[4] !== size) {
        t2 = $acbc23a21ff09bf1$var$getCardComponent(size, layout);
        $[3] = layout;
        $[4] = size;
        $[5] = t2;
    } else t2 = $[5];
    const CardComponent = t2;
    const showDescription = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || isDescriptionShown !== false;
    const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $acbc23a21ff09bf1$var$DynamicCardsContent : $acbc23a21ff09bf1$var$ManualCardsContent;
    let t3;
    if ($[6] !== CardComponent || $[7] !== CardsContentComponent || $[8] !== cardDimensions || $[9] !== contentId || $[10] !== extensionLocalId || $[11] !== isCompanyHub || $[12] !== isInViewMode || $[13] !== isTargetAudience || $[14] !== shouldAutoscrollCards || $[15] !== showDescription || $[16] !== validatedCardParams) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentComponent, {
            extensionLocalId: extensionLocalId,
            parameters: validatedCardParams,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isInViewMode: isInViewMode,
            contentId: contentId,
            cardDimensions: cardDimensions,
            shouldAutoscrollCards: shouldAutoscrollCards,
            CardComponent: CardComponent,
            showDescription: showDescription
        });
        $[6] = CardComponent;
        $[7] = CardsContentComponent;
        $[8] = cardDimensions;
        $[9] = contentId;
        $[10] = extensionLocalId;
        $[11] = isCompanyHub;
        $[12] = isInViewMode;
        $[13] = isTargetAudience;
        $[14] = shouldAutoscrollCards;
        $[15] = showDescription;
        $[16] = validatedCardParams;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId })=>{
    const validatedCardParams = (0, $f73aa100a9fdb106$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC;
    const cardDimensions = (0, $7ee74d072d6273e0$export$90cc9ab68d35b5b9)({
        cardSize: size,
        layout: layout
    });
    const CardComponent = $acbc23a21ff09bf1$var$getCardComponent(size, layout); // checking specifically if isDescriptionShown is false because if it's undefined,
    // it means that the dynamic cards were created from before and we want to show the descriptions they had
    const showDescription = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || isDescriptionShown !== false; /* only autoscroll cards when all below conditions meet:
                                                                                                   * 1. is in company hub
                                                                                                   * 2. orientation is in row (handled in validateCardParams)
                                                                                                   * 3. Autoscroll toggle is on
                                                                                                   * 4. user is in renderer
                                                                                                   * cards macro now includes features that are company hub specific. These features will be hidden for macros in non-hub pages
                                                                                                   * for more details refer to https://hello.atlassian.net/wiki/spaces/CLI/pages/4436003008/Hub+only+features
                                                                                                   */ 
    const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $acbc23a21ff09bf1$var$DynamicCardsContent : $acbc23a21ff09bf1$var$ManualCardsContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentComponent, {
        extensionLocalId: extensionLocalId,
        parameters: validatedCardParams,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: isInViewMode,
        contentId: contentId,
        cardDimensions: cardDimensions,
        shouldAutoscrollCards: shouldAutoscrollCards,
        CardComponent: CardComponent,
        showDescription: showDescription
    });
};
const $acbc23a21ff09bf1$var$CardsContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer } = t0;
    let t1;
    if ($[0] !== alignment || $[1] !== cardDimensions || $[2] !== cards || $[3] !== extensionLocalId || $[4] !== isInViewMode || $[5] !== isStacked || $[6] !== numberOfCards || $[7] !== renderCard || $[8] !== shouldAutoscrollCards || $[9] !== showAIDisclaimer) {
        t1 = shouldAutoscrollCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $508f24952640e58a$export$ac70d6b7d7a09503), {
            testId: "cards-extension",
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            cards: cards,
            renderCard: renderCard,
            showAIDisclaimer: showAIDisclaimer
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1036ce2280d59186$export$37f8d84bb48ae4b7), {
            testId: "cards-extension",
            extensionLocalId: extensionLocalId,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: isStacked,
            isInViewMode: isInViewMode,
            alignment: alignment,
            cards: cards,
            renderCard: renderCard,
            showAIDisclaimer: showAIDisclaimer,
            cardsContentFooter: (0, $7583eda5bec7c437$export$d1f75a226e49cd83)
        });
        $[0] = alignment;
        $[1] = cardDimensions;
        $[2] = cards;
        $[3] = extensionLocalId;
        $[4] = isInViewMode;
        $[5] = isStacked;
        $[6] = numberOfCards;
        $[7] = renderCard;
        $[8] = shouldAutoscrollCards;
        $[9] = showAIDisclaimer;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
} : ({ extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer })=>shouldAutoscrollCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $508f24952640e58a$export$ac70d6b7d7a09503), {
        testId: "cards-extension",
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1036ce2280d59186$export$37f8d84bb48ae4b7), {
        testId: "cards-extension",
        extensionLocalId: extensionLocalId,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: isStacked,
        isInViewMode: isInViewMode,
        alignment: alignment,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer,
        cardsContentFooter: (0, $7583eda5bec7c437$export$d1f75a226e49cd83)
    });
const $acbc23a21ff09bf1$var$ManualCardsContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: t1, showDescription: t2 } = t0;
    const isInViewMode = t1 === undefined ? false : t1;
    const showDescription = t2 === undefined ? true : t2;
    const { isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: storedTextColor, borderColor: borderColor, cornerRadius: cornerRadius, cornerStyle: cornerStyle } = parameters;
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)("cards-extension");
    let t3;
    if ($[0] !== backgroundColor || $[1] !== resolveTextColor || $[2] !== storedTextColor) {
        t3 = resolveTextColor({
            backgroundColor: backgroundColor,
            textColor: storedTextColor,
            defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)["cards.bg"]
        });
        $[0] = backgroundColor;
        $[1] = resolveTextColor;
        $[2] = storedTextColor;
        $[3] = t3;
    } else t3 = $[3];
    const textColor = t3;
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    let t4;
    if ($[4] !== audienceSegmentationGroupIds || $[5] !== cards || $[6] !== isCompanyHub || $[7] !== isInViewMode || $[8] !== isSegmentationShown || $[9] !== isTargetAudience || $[10] !== renderVariant || $[11] !== segmentationTarget) {
        t4 = {
            isCompanyHub: isCompanyHub,
            isSegmentationShown: isSegmentationShown,
            isTargetAudience: isTargetAudience,
            cards: cards,
            isInViewMode: isInViewMode,
            segmentationTarget: segmentationTarget,
            audienceSegmentationGroupIds: audienceSegmentationGroupIds,
            renderVariant: renderVariant
        };
        $[4] = audienceSegmentationGroupIds;
        $[5] = cards;
        $[6] = isCompanyHub;
        $[7] = isInViewMode;
        $[8] = isSegmentationShown;
        $[9] = isTargetAudience;
        $[10] = renderVariant;
        $[11] = segmentationTarget;
        $[12] = t4;
    } else t4 = $[12];
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)(t4);
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    let t5;
    if ($[13] !== experienceSuccessComponent) {
        t5 = experienceSuccessComponent || $acbc23a21ff09bf1$var$_temp;
        $[13] = experienceSuccessComponent;
        $[14] = t5;
    } else t5 = $[14];
    const ExperienceSuccess = t5;
    let t6;
    if ($[15] !== experienceStopComponent) {
        t6 = experienceStopComponent || $acbc23a21ff09bf1$var$_temp2;
        $[15] = experienceStopComponent;
        $[16] = t6;
    } else t6 = $[16];
    const ExperienceError = t6;
    const numberOfCards = filteredCards.length;
    let t7;
    if ($[17] !== CardComponent || $[18] !== backgroundColor || $[19] !== borderColor || $[20] !== cardDimensions || $[21] !== contentId || $[22] !== cornerRadius || $[23] !== cornerStyle || $[24] !== extensionLocalId || $[25] !== isAvatarShown || $[26] !== isIconShown || $[27] !== isInViewMode || $[28] !== isLabelShown || $[29] !== isPaddingEnabled || $[30] !== isPublishDateShown || $[31] !== isSocialStatsShown || $[32] !== onItemFailed || $[33] !== onItemSucceeded || $[34] !== showDescription || $[35] !== textColor) {
        t7 = (card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.075",
                key: card.cardId,
                xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: isInViewMode,
                isLabelShown: isLabelShown,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                isManualVariant: true,
                extensionLocalId: extensionLocalId,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerRadius: cornerRadius,
                cornerStyle: cornerStyle,
                showDescription: showDescription,
                ...card
            }));
        $[17] = CardComponent;
        $[18] = backgroundColor;
        $[19] = borderColor;
        $[20] = cardDimensions;
        $[21] = contentId;
        $[22] = cornerRadius;
        $[23] = cornerStyle;
        $[24] = extensionLocalId;
        $[25] = isAvatarShown;
        $[26] = isIconShown;
        $[27] = isInViewMode;
        $[28] = isLabelShown;
        $[29] = isPaddingEnabled;
        $[30] = isPublishDateShown;
        $[31] = isSocialStatsShown;
        $[32] = onItemFailed;
        $[33] = onItemSucceeded;
        $[34] = showDescription;
        $[35] = textColor;
        $[36] = t7;
    } else t7 = $[36];
    const renderManualCard = t7;
    const t8 = orientation === (0, $ikd73.Orientation).STACKED;
    let t9;
    if ($[37] !== alignment || $[38] !== cardDimensions || $[39] !== extensionLocalId || $[40] !== filteredCards || $[41] !== isInViewMode || $[42] !== numberOfCards || $[43] !== renderManualCard || $[44] !== shouldAutoscrollCards || $[45] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
            shouldAutoscrollCards: shouldAutoscrollCards,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: t8,
            isInViewMode: isInViewMode,
            alignment: alignment,
            extensionLocalId: extensionLocalId,
            cards: filteredCards,
            renderCard: renderManualCard
        });
        $[37] = alignment;
        $[38] = cardDimensions;
        $[39] = extensionLocalId;
        $[40] = filteredCards;
        $[41] = isInViewMode;
        $[42] = numberOfCards;
        $[43] = renderManualCard;
        $[44] = shouldAutoscrollCards;
        $[45] = t8;
        $[46] = t9;
    } else t9 = $[46];
    let t10;
    if ($[47] !== ExperienceSuccess || $[48] !== areAllItemsLoaded) {
        t10 = areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null);
        $[47] = ExperienceSuccess;
        $[48] = areAllItemsLoaded;
        $[49] = t10;
    } else t10 = $[49];
    let t11;
    if ($[50] !== ExperienceError || $[51] !== itemFailureError) {
        t11 = !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
            error: itemFailureError
        });
        $[50] = ExperienceError;
        $[51] = itemFailureError;
        $[52] = t11;
    } else t11 = $[52];
    let t12;
    if ($[53] !== t10 || $[54] !== t11 || $[55] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t10, t11);
        $[53] = t10;
        $[54] = t11;
        $[55] = t9;
        $[56] = t12;
    } else t12 = $[56];
    return t12;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription = true })=>{
    const { isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: storedTextColor, borderColor: borderColor, cornerRadius: cornerRadius, cornerStyle: cornerStyle } = parameters; // Keep black/white card text legible against the live brand colour; an
    // explicit brand-shade or custom-hex choice passes through untouched. Bound
    // to `textColor` so the render paths and the `useCallback` dependency arrays
    // below pick it up unchanged. See `hub-auto-text-color`.
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)('cards-extension');
    const textColor = resolveTextColor({
        backgroundColor: backgroundColor,
        textColor: storedTextColor,
        defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)['cards.bg']
    });
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cards,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = filteredCards.length;
    const renderManualCard = (0, $cozmU.useCallback)((card)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075",
            key: card.cardId,
            xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
            contentId: contentId,
            cardDimensions: cardDimensions,
            isPaddingEnabled: isPaddingEnabled,
            isAvatarShown: isAvatarShown,
            isPublishDateShown: isPublishDateShown,
            isSocialStatsShown: isSocialStatsShown,
            isIconShown: isIconShown,
            isInViewMode: isInViewMode,
            isLabelShown: isLabelShown,
            onCardSucceeded: onItemSucceeded,
            onCardFailed: onItemFailed,
            isManualVariant: true,
            extensionLocalId: extensionLocalId,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            cornerRadius: cornerRadius,
            cornerStyle: cornerStyle,
            showDescription: showDescription,
            ...card
        }));
    }, [
        extensionLocalId,
        contentId,
        cardDimensions,
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isLabelShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        backgroundColor,
        textColor,
        borderColor,
        cornerRadius,
        cornerStyle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
        shouldAutoscrollCards: shouldAutoscrollCards,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: orientation === (0, $ikd73.Orientation).STACKED,
        isInViewMode: isInViewMode,
        alignment: alignment,
        extensionLocalId: extensionLocalId,
        cards: filteredCards,
        renderCard: renderManualCard
    }), areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null), !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
        error: itemFailureError
    }));
};
const $acbc23a21ff09bf1$var$DynamicCardsContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    const { extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: t1, showDescription: showDescription } = t0;
    const isInViewMode = t1 === undefined ? false : t1;
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: storedTextColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters;
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)("cards-extension");
    let t2;
    if ($[0] !== backgroundColor || $[1] !== resolveTextColor || $[2] !== storedTextColor) {
        t2 = resolveTextColor({
            backgroundColor: backgroundColor,
            textColor: storedTextColor,
            defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)["cards.bg"]
        });
        $[0] = backgroundColor;
        $[1] = resolveTextColor;
        $[2] = storedTextColor;
        $[3] = t2;
    } else t2 = $[3];
    const textColor = t2;
    const { cards: cards, loading: loading, error: error } = (0, $6d3e30142bf823a9$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    let t3;
    if ($[4] !== experienceSuccessComponent) {
        t3 = experienceSuccessComponent || $acbc23a21ff09bf1$var$_temp3;
        $[4] = experienceSuccessComponent;
        $[5] = t3;
    } else t3 = $[5];
    const ExperienceSuccess = t3;
    let t4;
    if ($[6] !== experienceStopComponent) {
        t4 = experienceStopComponent || $acbc23a21ff09bf1$var$_temp4;
        $[6] = experienceStopComponent;
        $[7] = t4;
    } else t4 = $[7];
    const ExperienceError = t4;
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $hjUDQ.Height).SMALL;
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) {
        let t5;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, (/*@__PURE__*/$parcel$interopDefault($6461dd9a11ba8e64$exports)))(3, $acbc23a21ff09bf1$var$_temp5);
            $[8] = t5;
        } else t5 = $[8];
        cardsWithEmptyDefault = t5;
    }
    let t5;
    if ($[9] !== audienceSegmentationGroupIds || $[10] !== cardsWithEmptyDefault || $[11] !== isCompanyHub || $[12] !== isInViewMode || $[13] !== isSegmentationShown || $[14] !== isTargetAudience || $[15] !== renderVariant || $[16] !== segmentationTarget) {
        t5 = {
            isCompanyHub: isCompanyHub,
            isSegmentationShown: isSegmentationShown,
            isTargetAudience: isTargetAudience,
            cards: cardsWithEmptyDefault,
            isInViewMode: isInViewMode,
            segmentationTarget: segmentationTarget,
            audienceSegmentationGroupIds: audienceSegmentationGroupIds,
            renderVariant: renderVariant
        };
        $[9] = audienceSegmentationGroupIds;
        $[10] = cardsWithEmptyDefault;
        $[11] = isCompanyHub;
        $[12] = isInViewMode;
        $[13] = isSegmentationShown;
        $[14] = isTargetAudience;
        $[15] = renderVariant;
        $[16] = segmentationTarget;
        $[17] = t5;
    } else t5 = $[17];
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)(t5);
    let t6;
    if ($[18] !== CardComponent || $[19] !== backgroundColor || $[20] !== borderColor || $[21] !== cardDimensions || $[22] !== contentId || $[23] !== cornerStyle || $[24] !== filters || $[25] !== isAvatarShown || $[26] !== isIconShown || $[27] !== isImageShown || $[28] !== isInViewMode || $[29] !== isPaddingEnabled || $[30] !== isPublishDateShown || $[31] !== isSocialStatsShown || $[32] !== layout || $[33] !== loading || $[34] !== numberOfCards || $[35] !== onItemFailed || $[36] !== onItemSucceeded || $[37] !== showDescription || $[38] !== size || $[39] !== textColor) {
        t6 = (card)=>{
            const isResultEmpty = !numberOfCards || !card?.link;
            if (!filters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_FILTER
            });
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddecac981a5dbce2$export$f67f215fe23c6b24), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout
            });
            if (isResultEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_RESULTS
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.075",
                key: card.cardId,
                xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isImageShown: isImageShown,
                isInViewMode: !!isInViewMode,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                enableSnippetRenderer: true,
                showDescription: showDescription,
                ...card
            }));
        };
        $[18] = CardComponent;
        $[19] = backgroundColor;
        $[20] = borderColor;
        $[21] = cardDimensions;
        $[22] = contentId;
        $[23] = cornerStyle;
        $[24] = filters;
        $[25] = isAvatarShown;
        $[26] = isIconShown;
        $[27] = isImageShown;
        $[28] = isInViewMode;
        $[29] = isPaddingEnabled;
        $[30] = isPublishDateShown;
        $[31] = isSocialStatsShown;
        $[32] = layout;
        $[33] = loading;
        $[34] = numberOfCards;
        $[35] = onItemFailed;
        $[36] = onItemSucceeded;
        $[37] = showDescription;
        $[38] = size;
        $[39] = textColor;
        $[40] = t6;
    } else t6 = $[40];
    const renderDynamicCard = t6;
    const t7 = orientation === (0, $ikd73.Orientation).STACKED;
    let t8;
    if ($[41] !== alignment || $[42] !== cardDimensions || $[43] !== extensionLocalId || $[44] !== filteredCards || $[45] !== isInViewMode || $[46] !== numberOfCards || $[47] !== renderDynamicCard || $[48] !== shouldAutoscrollCards || $[49] !== showAIDisclaimer || $[50] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
            shouldAutoscrollCards: shouldAutoscrollCards,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: t7,
            isInViewMode: isInViewMode,
            alignment: alignment,
            extensionLocalId: extensionLocalId,
            cards: filteredCards,
            renderCard: renderDynamicCard,
            showAIDisclaimer: showAIDisclaimer
        });
        $[41] = alignment;
        $[42] = cardDimensions;
        $[43] = extensionLocalId;
        $[44] = filteredCards;
        $[45] = isInViewMode;
        $[46] = numberOfCards;
        $[47] = renderDynamicCard;
        $[48] = shouldAutoscrollCards;
        $[49] = showAIDisclaimer;
        $[50] = t7;
        $[51] = t8;
    } else t8 = $[51];
    let t9;
    if ($[52] !== error) {
        t9 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f15264ed5f302311$export$533cd3269e981a31), {
            error: error
        });
        $[52] = error;
        $[53] = t9;
    } else t9 = $[53];
    let t10;
    if ($[54] !== ExperienceSuccess || $[55] !== areAllItemsLoaded) {
        t10 = areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null);
        $[54] = ExperienceSuccess;
        $[55] = areAllItemsLoaded;
        $[56] = t10;
    } else t10 = $[56];
    let t11;
    if ($[57] !== ExperienceError || $[58] !== itemFailureError) {
        t11 = !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
            error: itemFailureError
        });
        $[57] = ExperienceError;
        $[58] = itemFailureError;
        $[59] = t11;
    } else t11 = $[59];
    let t12;
    if ($[60] !== t10 || $[61] !== t11 || $[62] !== t8 || $[63] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9, t10, t11);
        $[60] = t10;
        $[61] = t11;
        $[62] = t8;
        $[63] = t9;
        $[64] = t12;
    } else t12 = $[64];
    return t12;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription })=>{
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isImageShown: isImageShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: storedTextColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters; // Same auto-readability binding as the manual variant above.
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)('cards-extension');
    const textColor = resolveTextColor({
        backgroundColor: backgroundColor,
        textColor: storedTextColor,
        defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)['cards.bg']
    });
    const { cards: cards, loading: loading, error: error } = (0, $6d3e30142bf823a9$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $hjUDQ.Height).SMALL;
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) cardsWithEmptyDefault = (0, (/*@__PURE__*/$parcel$interopDefault($6461dd9a11ba8e64$exports)))(3, ()=>({
            cardId: '',
            link: ''
        }));
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cardsWithEmptyDefault,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const renderDynamicCard = (0, $cozmU.useCallback)((card)=>{
        const isResultEmpty = !numberOfCards || !card?.link;
        if (!filters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_FILTER
        });
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddecac981a5dbce2$export$f67f215fe23c6b24), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout
        });
        if (isResultEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_RESULTS
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075",
            key: card.cardId,
            xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
            contentId: contentId,
            cardDimensions: cardDimensions,
            isPaddingEnabled: isPaddingEnabled,
            isAvatarShown: isAvatarShown,
            isPublishDateShown: isPublishDateShown,
            isSocialStatsShown: isSocialStatsShown,
            isIconShown: isIconShown,
            isImageShown: isImageShown,
            isInViewMode: !!isInViewMode,
            onCardSucceeded: onItemSucceeded,
            onCardFailed: onItemFailed,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            cornerStyle: cornerStyle,
            enableSnippetRenderer: true,
            showDescription: showDescription,
            ...card
        }));
    }, [
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isSocialStatsShown,
        isIconShown,
        isImageShown,
        showDescription,
        filters,
        size,
        contentId,
        cardDimensions,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        loading,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle,
        layout,
        numberOfCards
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
        shouldAutoscrollCards: shouldAutoscrollCards,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: orientation === (0, $ikd73.Orientation).STACKED,
        isInViewMode: isInViewMode,
        alignment: alignment,
        extensionLocalId: extensionLocalId,
        cards: filteredCards,
        renderCard: renderDynamicCard,
        showAIDisclaimer: showAIDisclaimer
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f15264ed5f302311$export$533cd3269e981a31), {
        error: error
    }), areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null), !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
        error: itemFailureError
    }));
};
function $acbc23a21ff09bf1$var$_temp() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp2() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp3() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp4() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp5() {
    return {
        cardId: "",
        link: ""
    };
}


const $e1207a88999a131e$export$9db933359d5c5243 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { extensionNode: extensionNode, contentId: contentId, mode: t1 } = t0;
    const mode = t1 === undefined ? (0, $hjUDQ.ExtensionMode).RENDERER : t1;
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $cfM7x.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $cozmU.Fragment);
    let t2;
    if ($[0] !== extensionNode) {
        t2 = extensionNode || {};
        $[0] = extensionNode;
        $[1] = t2;
    } else t2 = $[1];
    const { parameters: parameters, localId: t3 } = t2;
    const localId = t3 === undefined ? "" : t3;
    if (!parameters) return null;
    const t4 = !parameters;
    const t5 = parameters?.renderVariant;
    const t6 = parameters?.version;
    const t7 = parameters?.isSegmentationShown;
    let t8;
    if ($[2] !== isCompanyHub || $[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
        t8 = {
            renderVariant: t5,
            version: t6,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: t7
        };
        $[2] = isCompanyHub;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const t9 = mode === (0, $hjUDQ.ExtensionMode).RENDERER;
    let t10;
    if ($[7] !== contentId || $[8] !== isCompanyHub || $[9] !== isTargetAudience || $[10] !== localId || $[11] !== parameters || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbc23a21ff09bf1$export$bab15f92b6d84cb6), {
            extensionLocalId: localId,
            parameters: parameters,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isInViewMode: t9,
            contentId: contentId
        });
        $[7] = contentId;
        $[8] = isCompanyHub;
        $[9] = isTargetAudience;
        $[10] = localId;
        $[11] = parameters;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== SmartCardProvider || $[15] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardProvider, null, t10);
        $[14] = SmartCardProvider;
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== contentId || $[18] !== extensionNode || $[19] !== mode || $[20] !== t11 || $[21] !== t4 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RH40.HubExtensionsWrapper), {
            mode: mode,
            extensionNode: extensionNode,
            contentId: contentId,
            showNoDataState: t4,
            packageName: "cards-extension",
            analyticsAttributes: t8
        }, t11);
        $[17] = contentId;
        $[18] = extensionNode;
        $[19] = mode;
        $[20] = t11;
        $[21] = t4;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    return t12;
} : ({ extensionNode: extensionNode, contentId: contentId, mode: mode = (0, $hjUDQ.ExtensionMode).RENDERER })=>{
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $cfM7x.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $cozmU.Fragment);
    const { parameters: parameters, localId: localId = '' } = extensionNode || {};
    if (!parameters) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RH40.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "cards-extension",
        analyticsAttributes: {
            renderVariant: parameters?.renderVariant,
            version: parameters?.version,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: parameters?.isSegmentationShown
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbc23a21ff09bf1$export$bab15f92b6d84cb6), {
        extensionLocalId: localId,
        parameters: parameters,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: mode === (0, $hjUDQ.ExtensionMode).RENDERER,
        contentId: contentId
    })));
};
const $e1207a88999a131e$export$4956ae2d90a2bbeb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let PropsProvider;
    let props;
    if ($[0] !== t0) {
        ({ propsProvider: PropsProvider, ...props } = t0);
        $[0] = t0;
        $[1] = PropsProvider;
        $[2] = props;
    } else {
        PropsProvider = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1207a88999a131e$export$9db933359d5c5243, props);
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== PropsProvider || $[6] !== props || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PropsProvider, props, t1);
        $[5] = PropsProvider;
        $[6] = props;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PropsProvider, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1207a88999a131e$export$9db933359d5c5243, props));
module.exports["CardsExtensionBase"] = $e1207a88999a131e$export$9db933359d5c5243;
module.exports["CardsExtension"] = $e1207a88999a131e$export$4956ae2d90a2bbeb;

});

parcelRegister("5RH40", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $65DSU = parcelRequire("65DSU");


var $cfM7x = parcelRequire("cfM7x");


var $hjUDQ = parcelRequire("hjUDQ");


var $d6u4w = parcelRequire("d6u4w");


var $3eDML = parcelRequire("3eDML");


var $ame4Z = parcelRequire("ame4Z");


var $2t092 = parcelRequire("2t092");

const $c10f9c6572a37e37$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $hjUDQ.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $cfM7x.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $cozmU.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $ame4Z.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null)
    };
    (0, $cozmU.useEffect)(()=>{
        if (mode === (0, $hjUDQ.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: extensionKey || 'unknown-hub-extension'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorBoundaryComponent, {
        ...errorBoundaryProps,
        shouldForceError: (0, $2t092.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceStart, null), hasParameters ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: extensionKey
    })));
};
module.exports["HubExtensionsWrapper"] = $c10f9c6572a37e37$export$1b8348eac06ebe09;

});

parcelRegister("d6u4w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");


var $cfM7x = parcelRequire("cfM7x");


var $iP3ib = parcelRequire("iP3ib");


var $icRfg = parcelRequire("icRfg");

const $f11bc349985cedb8$var$styles = {
    baseStyles: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    configPanelStyles: "_0jFU0VE1Ft",
    extensionStyles: "_0jFU0VN91d"
};
const $f11bc349985cedb8$export$dd91c9257a0f1cd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { source: t1, isConfigPanel: isConfigPanel } = t0;
    const source = t1 === undefined ? "" : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[0] !== source) {
        t2 = source?.charAt(0).toUpperCase();
        $[0] = source;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== source) {
        t3 = source?.slice(1);
        $[2] = source;
        $[3] = t3;
    } else t3 = $[3];
    const extensionSourceName = t2 + t3;
    let t4;
    let t5;
    if ($[4] !== extensionSourceName || $[5] !== isConfigPanel || $[6] !== submitError) {
        t4 = ()=>{
            const errorMessage = `${extensionSourceName} ${isConfigPanel ? "config panel" : "extension"} failed to render. No parameters.`;
            submitError?.(new Error(errorMessage));
        };
        t5 = [
            extensionSourceName,
            isConfigPanel,
            submitError
        ];
        $[4] = extensionSourceName;
        $[5] = isConfigPanel;
        $[6] = submitError;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles;
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, t6);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== intl) {
        t8 = intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText);
        $[11] = intl;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
            header: t8,
            description: t9,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
        });
        $[14] = t8;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t7
        }, t10);
        $[16] = t10;
        $[17] = t7;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
} : ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $cozmU.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
    }));
};
module.exports["NoExtensionData"] = $f11bc349985cedb8$export$dd91c9257a0f1cd4;

});

parcelRegister("iP3ib", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("icRfg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8e4fbaddba5526c6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8e4fbaddba5526c6$export$defe85febe8b728c;

});

parcelRegister("2t092", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $123f2f203b618ce4$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $123f2f203b618ce4$export$3617e2677e53ded6;

});

parcelRegister("fZvv3", function(module, exports) {

var $coD4j = parcelRequire("coD4j");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $ba44fcbbb2d24900$var$castFunction(value) {
    return typeof value == 'function' ? value : $coD4j;
}
module.exports = $ba44fcbbb2d24900$var$castFunction;

});

parcelRegister("k5vii", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1f4cda36fc78bdf362eb11a99399a81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9fc8c9ec2597c1b$var$_react = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e9fc8c9ec2597c1b$var$_iconNew = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e9fc8c9ec2597c1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-pause
 * Usage guidance:
 * Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9fc8c9ec2597c1b$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $e9fc8c9ec2597c1b$var$_react.default.createElement($e9fc8c9ec2597c1b$var$_iconNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e9fc8c9ec2597c1b$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $e9fc8c9ec2597c1b$var$_default = module.exports.default = $e9fc8c9ec2597c1b$var$VideoPauseIcon;

});

parcelRegister("cvDI4", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $LvVJP = parcelRequire("LvVJP");

const $96cd3f35152a45d9$export$a43b6bbf2f1b5e96 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $LvVJP.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
module.exports["CommentCountElement"] = $96cd3f35152a45d9$export$a43b6bbf2f1b5e96;

});

parcelRegister("4buyQ", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $7sCIj = parcelRequire("7sCIj");

const $55b74caacac7f327$export$cb2b1990006f041b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7sCIj.default), {
        hideDatePrefix: props?.hideDatePrefix,
        color: props?.color,
        onRender: props?.onRender,
        fontSize: props?.fontSize
    });
};
module.exports["ModifiedOnElement"] = $55b74caacac7f327$export$cb2b1990006f041b;

});

parcelRegister("6gjqU", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $4GRqQ = parcelRequire("4GRqQ");

const $b1780bc8b62e343f$export$d630834382353545 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4GRqQ.default), {
        hideFormat: props?.hideFormat,
        color: props?.color,
        onRender: props?.onRender,
        textPrefix: props?.textPrefix,
        fontSize: props?.fontSize
    });
};
module.exports["OwnedByElement"] = $b1780bc8b62e343f$export$d630834382353545;

});

parcelRegister("fEbt0", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $cl3v4 = parcelRequire("cl3v4");

const $214bea8d005f747b$export$633ffcc4029e4e39 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cl3v4.default), {
        onRender: props?.onRender
    });
};
module.exports["OwnedByGroupElement"] = $214bea8d005f747b$export$633ffcc4029e4e39;

});

parcelRegister("keB0x", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $eIk5O = parcelRequire("eIk5O");

const $aed3b7198b7ebd14$export$5ecf9c2b4f9ce084 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIk5O.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
module.exports["ReactCountElement"] = $aed3b7198b7ebd14$export$5ecf9c2b4f9ce084;

});

parcelRegister("7j5Rg", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $8Mb1e = parcelRequire("8Mb1e");

const $06dae2c1d20cadc4$export$8687dc32e81b32c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Mb1e.default), props);
module.exports["UnresolvedAction"] = $06dae2c1d20cadc4$export$8687dc32e81b32c2;

});

parcelRegister("3s2S5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4yccB = parcelRequire("4yccB");


var $jlbje = parcelRequire("jlbje");

const $b13f9faa6d57a0da$var$isEmpty = (s)=>!s || s.trim() === '';
const $b13f9faa6d57a0da$export$5af1f6d040dd2f99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageSrc)=>{
    const $ = (0, $bDgLe.c)(7);
    const [resolvedUrl, setResolvedUrl] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[0] !== imageSrc || $[1] !== link) {
        t0 = $b13f9faa6d57a0da$var$isEmpty(imageSrc) && !!link && (0, $jlbje.isLoomLink)(link);
        $[0] = imageSrc;
        $[1] = link;
        $[2] = t0;
    } else t0 = $[2];
    const shouldRefetch = t0;
    let t1;
    let t2;
    if ($[3] !== link || $[4] !== shouldRefetch) {
        t1 = ()=>{
            if (!shouldRefetch || !link) {
                setResolvedUrl(undefined);
                return;
            }
            let cancelled = false;
            const client = new (0, $4yccB.default)();
            client.fetchData(link).then((data)=>{
                if (cancelled) return;
                const url = data?.data?.image?.url;
                if (url) setResolvedUrl(url);
            }).catch($b13f9faa6d57a0da$var$_temp);
            return ()=>{
                cancelled = true;
            };
        };
        t2 = [
            link,
            shouldRefetch
        ];
        $[3] = link;
        $[4] = shouldRefetch;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!$b13f9faa6d57a0da$var$isEmpty(imageSrc)) return imageSrc;
    if (shouldRefetch) return resolvedUrl;
} : (link, imageSrc)=>{
    const [resolvedUrl, setResolvedUrl] = (0, $cozmU.useState)(undefined);
    const shouldRefetch = $b13f9faa6d57a0da$var$isEmpty(imageSrc) && !!link && (0, $jlbje.isLoomLink)(link);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRefetch || !link) {
            setResolvedUrl(undefined);
            return;
        }
        let cancelled = false;
        const client = new (0, $4yccB.default)();
        client.fetchData(link).then((data)=>{
            if (cancelled) return;
            const url = data?.data?.image?.url;
            if (url) setResolvedUrl(url);
        }).catch(()=>{
        // Ignore fetch errors; component will show no image
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        link,
        shouldRefetch
    ]);
    if (!$b13f9faa6d57a0da$var$isEmpty(imageSrc)) return imageSrc;
    if (shouldRefetch) return resolvedUrl;
    return undefined;
};
function $b13f9faa6d57a0da$var$_temp() {}
module.exports["useLoomThumbnailUrl"] = $b13f9faa6d57a0da$export$5af1f6d040dd2f99;

});

parcelRegister("jlbje", function(module, exports) {
/**
 * Returns true when url is a Loom CDN thumbnail that includes a signed Policy
 * (and thus expires). Such URLs should not be stored in ADF.
 * Public loom URLs do not include a Policy.
 */ const $402d7553b5dc4ef6$export$e9af613851c565cf = (url)=>{
    return typeof url === 'string' && url.includes('cdn.loom.com') && url.includes('Policy');
};
const $402d7553b5dc4ef6$export$fbf81d5b14dce964 = (link)=>{
    if (typeof link !== 'string' || !link) return false;
    try {
        const host = new URL(link).hostname.toLowerCase();
        return (host === 'loom.com' || host === 'www.loom.com') && link.includes('/share/');
    } catch  {
        return false;
    }
};
module.exports["isPrivateLoomImageUrl"] = $402d7553b5dc4ef6$export$e9af613851c565cf;
module.exports["isLoomLink"] = $402d7553b5dc4ef6$export$fbf81d5b14dce964;

});

parcelRegister("epZ7a", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $hsIfr = parcelRequire("hsIfr");

const $356f9a22b0bf3065$export$4d177e8e493d864d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        size: props?.iconTileSize === 24 ? (0, $4yYAm.SmartLinkSize).Large : (0, $4yYAm.SmartLinkSize).Medium,
        render: props?.render
    });
};
module.exports["LinkIconElement"] = $356f9a22b0bf3065$export$4d177e8e493d864d;

});

parcelRegister("iLpJO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $57p4j = parcelRequire("57p4j");

const $3f6c89efab089b35$var$skeletonWrapperStyles = null;
const $3f6c89efab089b35$var$emojiSkeletonStyles = null;
const $3f6c89efab089b35$export$9fc60f86d5a6479f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { height: height, loadingMargin: loadingMargin } = t0;
    const PLACEHOLDER_SIZE = height;
    let t1;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== loadingMargin) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ $cozmU.createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_0bjKvDzXzM _3iDTPbvbI6 _0KLXruGsB2 _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = loadingMargin;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ height: height, loadingMargin: loadingMargin })=>{
    const PLACEHOLDER_SIZE = height;
    return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: loadingMargin
            },
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _3iDTPbvbI6 _0KLXruGsB2 _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $3f6c89efab089b35$export$9fc60f86d5a6479f;

});

parcelRegister("esAkB", function(module, exports) {

let $a86fdcda28ed6241$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a86fdcda28ed6241$var$load("7BHAC"),
    $a86fdcda28ed6241$var$load("N3TvS"),
    $a86fdcda28ed6241$var$load("2rpiM")
]).then(()=>parcelRequire('ePMfy'));

});

parcelRegister("8ngiY", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("fxqZn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Bitbucket" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function BitbucketIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["BitbucketIcon"] = $d28d5aedb34440f3$export$5fc1066e677788d4;

});

parcelRegister("hZx6a", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Compass" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CompassIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CompassIcon"] = $08074ca1ab8ce06c$export$f7857fe64d7161d9;

});

parcelRegister("8JGXU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Trello" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function TrelloIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TrelloIcon"] = $24d0e9af25866402$export$4384da9b8b140bf4;

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("1SyEw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $9d7fd522dc0dc942$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $9d7fd522dc0dc942$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
const $9d7fd522dc0dc942$export$3c6158790f5e01c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraServiceManagementIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira Service Management" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $9d7fd522dc0dc942$var$svg,
            customThemeSvg: $9d7fd522dc0dc942$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function JiraServiceManagementIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $9d7fd522dc0dc942$var$svg,
        customThemeSvg: $9d7fd522dc0dc942$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraServiceManagementIcon"] = $9d7fd522dc0dc942$export$3c6158790f5e01c4;

});

parcelRegister("7jfHQ", function(module, exports) {
const $dc3179d69ab4f7dc$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
module.exports["getObjectIconUrl"] = $dc3179d69ab4f7dc$export$bcf275804417edda;

});

parcelRegister("jZuR8", function(module, exports) {

var $fLtAn = parcelRequire("fLtAn");

const $bbb41cf47ef9db08$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>(0, $fLtAn.currentSiteCloudIdService).get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudId"] = $bbb41cf47ef9db08$export$143af22820ae9de;

});

parcelRegister("fLtAn", function(module, exports) {

var $aPG8c = parcelRequire("aPG8c");


var $dWxvX = parcelRequire("dWxvX");

const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = (0, $dWxvX.getCurrentSiteCloudIdLocalStorageKey)();
const $aff19b92c38e9221$export$1956112846aa829e = new (0, $aPG8c.CurrentSiteCloudIdService)();
module.exports["currentSiteCloudIdService"] = $aff19b92c38e9221$export$1956112846aa829e;

});

parcelRegister("aPG8c", function(module, exports) {

var $f9XbP = parcelRequire("f9XbP");


var $j39Hd = parcelRequire("j39Hd");


var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

const $e53a9d084474949f$var$smartCardStorage = new (0, $f9XbP.StorageClient)((0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE);
class $e53a9d084474949f$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $e53a9d084474949f$var$smartCardStorage.getItem((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $e53a9d084474949f$var$smartCardStorage.setItemWithExpiry((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash), cloudId, (0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_TTL_MS);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = (0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
module.exports["CurrentSiteCloudIdService"] = $e53a9d084474949f$export$a15da722a3b05509;

});

parcelRegister("70pj3", function(module, exports) {

var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

function $9ab1e04492b578dd$export$87f317e381996380(baseUriWithNoTrailingSlash = '') {
    return `${(0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent((0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash))}`;
}
module.exports["cloudIdStorageItemKey"] = $9ab1e04492b578dd$export$87f317e381996380;

});

parcelRegister("8RXRs", function(module, exports) {
const $144f2fcd8359dd2a$export$a05eb2f7d4daba17 = {
    SMART_CARD_STORAGE_SCOPE: 'smart-card-social-proof',
    CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX: 'site-cloud-id:v1:',
    CURRENT_SITE_CLOUD_ID_TTL_MS: 86400000
};
module.exports["currentSiteCloudIdConstants"] = $144f2fcd8359dd2a$export$a05eb2f7d4daba17;

});

parcelRegister("jcfU0", function(module, exports) {
function $b9978992253e250c$export$d01aa4af38c023bb(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
module.exports["normalizeBaseUri"] = $b9978992253e250c$export$d01aa4af38c023bb;

});

parcelRegister("dWxvX", function(module, exports) {

var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");

const $67e1c748f74c28e2$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${(0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE}_${(0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash)}`;
module.exports["getCurrentSiteCloudIdLocalStorageKey"] = $67e1c748f74c28e2$export$dea1a8bc5840f118;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $ebRBT = parcelRequire("ebRBT");

// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $c358709489b4576e$var$FileIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $ebRBT = parcelRequire("ebRBT");

// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $3736b97729106be6$var$ChartBarIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $ebRBT = parcelRequire("ebRBT");

// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("dSs0x", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8838e9e9c5b34afb$export$736a7b9a8e50ca01 = (previewUrl, { hostProduct: hostProduct, themeState: themeState })=>{
    try {
        const url = new URL(previewUrl);
        if (themeState) url.searchParams.append('themeState', (0, $fcaWu.themeObjectToString)(themeState));
        if (hostProduct) url.searchParams.set('hostProduct', hostProduct);
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $8838e9e9c5b34afb$export$4470f298c61a79da = (previewUrl, themeState)=>$8838e9e9c5b34afb$export$736a7b9a8e50ca01(previewUrl, {
        themeState: themeState
    });
module.exports["getPreviewUrlWithEmbedContext"] = $8838e9e9c5b34afb$export$736a7b9a8e50ca01;
module.exports["getPreviewUrlWithTheme"] = $8838e9e9c5b34afb$export$4470f298c61a79da;

});

parcelRegister("di1bl", function(module, exports) {
const $7def949369507160$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
module.exports["getIframeSandboxAttribute"] = $7def949369507160$export$9b7e6a102056a387;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $19zon = parcelRequire("19zon");


var $f24cK = parcelRequire("f24cK");


var $bhs2L = parcelRequire("bhs2L");

const $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(0, $bhs2L.loadEmbeddedConfluencePage)().then((Page)=>({
            default: Page
        })));
const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    const InjectedPage = (0, $f24cK.useEmbeddedConfluencePage)();
    const Page = InjectedPage ?? $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage;
    const fallbackIframe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallbackIframe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Page, {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    })) : fallbackIframe;
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.setGlobalTheme)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("f24cK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $aa21c625d0c25974$var$EmbeddedConfluencePageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $aa21c625d0c25974$export$542af7a009641f95 = $aa21c625d0c25974$var$EmbeddedConfluencePageContext.Provider;
const $aa21c625d0c25974$export$95a59d66783a54b3 = ()=>(0, $cozmU.useContext)($aa21c625d0c25974$var$EmbeddedConfluencePageContext);
module.exports["useEmbeddedConfluencePage"] = $aa21c625d0c25974$export$95a59d66783a54b3;

});

parcelRegister("bhs2L", function(module, exports) {
/**
 * Async factory for the Confluence embed `Page` component.
 *
 * Kept in its own module so `@atlaskit/embedded-confluence/page` is a dynamic
 * import only — hosts that never render a Confluence embed URL do not
 * download this chunk.
 */ 
async function $b32c583ef23c7f79$export$61cc2a15eefecd0b() {
    const { Page: Page } = await (parcelRequire("eyLyZ"));
    return Page;
}
module.exports["loadEmbeddedConfluencePage"] = $b32c583ef23c7f79$export$61cc2a15eefecd0b;

});

parcelRegister("eyLyZ", function(module, exports) {

let $a99922c44b7ff1bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a99922c44b7ff1bc$var$load("6wr18"),
    $a99922c44b7ff1bc$var$load("ffEVr"),
    $a99922c44b7ff1bc$var$load("bm0AN"),
    $a99922c44b7ff1bc$var$load("Wowvf"),
    $a99922c44b7ff1bc$var$load("7k9oy"),
    $a99922c44b7ff1bc$var$load("35mvB"),
    $a99922c44b7ff1bc$var$load("hhss7"),
    $a99922c44b7ff1bc$var$load("24IOT")
]).then(()=>parcelRequire('jpl1A'));

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("hQVHS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $87b9bf478c0c1673$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
const $87b9bf478c0c1673$export$5ed3e1bb3b04fc02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Projects" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $87b9bf478c0c1673$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ProjectsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $87b9bf478c0c1673$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ProjectsIcon"] = $87b9bf478c0c1673$export$5ed3e1bb3b04fc02;

});

parcelRegister("6vPLm", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $83056c684d55bb4d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $83056c684d55bb4d$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
const $83056c684d55bb4d$export$d89497e7f33ca6f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AssetsIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Assets" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $83056c684d55bb4d$var$svg,
            customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            isAssets: true,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function AssetsIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $83056c684d55bb4d$var$svg,
        customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["AssetsIcon"] = $83056c684d55bb4d$export$d89497e7f33ca6f5;

});

parcelRegister("g0fSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $iDrrr = parcelRequire("iDrrr");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");

const $e5bbb38f64c6a3e7$export$9f7977d4a2561bee = (Component)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaClient = (0, $cozmU.useMemo)(()=>existingMediaClient ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));
module.exports["withMediaClient"] = $e5bbb38f64c6a3e7$export$9f7977d4a2561bee;

});

parcelRegister("dL3KD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $b10ebbefbae983ec$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
const $b10ebbefbae983ec$export$1e02e7298035a77c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FocusIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Focus" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $b10ebbefbae983ec$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function FocusIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $b10ebbefbae983ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["FocusIcon"] = $b10ebbefbae983ec$export$1e02e7298035a77c;

});

parcelRegister("33FWk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $9f7a3b7caba550ed$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9f7a3b7caba550ed$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
const $9f7a3b7caba550ed$export$21bfbeb62fdcce8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira Product Discovery" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $9f7a3b7caba550ed$var$svg,
            customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function JiraProductDiscoveryIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $9f7a3b7caba550ed$var$svg,
        customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraProductDiscoveryIcon"] = $9f7a3b7caba550ed$export$21bfbeb62fdcce8d;

});

parcelRegister("hupj2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb0eeb73da830bbb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
const $fb0eeb73da830bbb$export$4b05688514531169 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TalentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Talent" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $fb0eeb73da830bbb$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function TalentIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $fb0eeb73da830bbb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TalentIcon"] = $fb0eeb73da830bbb$export$4b05688514531169;

});

parcelRegister("8zgL4", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $j6gAQ = parcelRequire("j6gAQ");


var $jSNLM = parcelRequire("jSNLM");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $63ce9773a8ff0858$var$map(collection, iteratee) {
    var func = $1ScXu(collection) ? $79D42 : $jSNLM;
    return func(collection, $j6gAQ(iteratee, 3));
}
module.exports = $63ce9773a8ff0858$var$map;

});

parcelRegister("LI9nv", function(module, exports) {

module.exports = (parcelRequire("gFnRy"));

});

parcelRegister("gFnRy", function(module, exports) {

var $7aPLP = parcelRequire("7aPLP");


var $bNHBU = parcelRequire("bNHBU");


var $fZvv3 = parcelRequire("fZvv3");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $c222fc52732a8568$var$forEach(collection, iteratee) {
    var func = $1ScXu(collection) ? $7aPLP : $bNHBU;
    return func(collection, $fZvv3(iteratee));
}
module.exports = $c222fc52732a8568$var$forEach;

});

parcelRegister("5Sbqg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $bIp5p = parcelRequire("bIp5p");


var $dhLnb = parcelRequire("dhLnb");


var $9n61H = parcelRequire("9n61H");


var $aOuIh = parcelRequire("aOuIh");


var $gXR7h = parcelRequire("gXR7h");


var $cT2iI = parcelRequire("cT2iI");


var $je216 = parcelRequire("je216");


var $hjUDQ = parcelRequire("hjUDQ");


var $VdC3b = parcelRequire("VdC3b");

const $346548928aed178e$var$getImage = (src, contentId, alt)=>{
    return src ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: src,
        imageAlt: alt,
        shouldShowExternalSiteImage: true
    }) : null;
};
const $346548928aed178e$var$styles = {
    frameStyles: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3yilb87p2s"
};
const $346548928aed178e$export$d6098952608bbca6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { testId: testId, contentId: contentId, source: source, link: link, title: title, description: description, backgroundColor: t1, textColor: t2, height: height, layout: t3, imageData: imageData, imageAltText: imageAltText, width: width, imageWidthPercentage: imageWidthPercentage, buttonStyle: t4, buttonText: buttonText, hasRoundedCorners: hasRoundedCorners, cornerRadiusOverride: cornerRadiusOverride, index: t5, selectedFrameIndex: t6, frameSetLength: t7, extensionLocalId: extensionLocalId } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-input, #FFFFFF)" : t1;
    const textColor = t2 === undefined ? (0, $cT2iI.frameNewParametersV2).textColor : t2;
    const layout = t3 === undefined ? (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT : t3;
    const buttonStyle = t4 === undefined ? (0, $cT2iI.frameNewParametersV2).buttonStyle : t4;
    const index = t5 === undefined ? 0 : t5;
    const selectedFrameIndex = t6 === undefined ? -1 : t6;
    const frameSetLength = t7 === undefined ? 1 : t7;
    const intl = (0, $kSwu1.useIntl)();
    const cardRef = (0, $cozmU.useRef)(null);
    const [t8] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId } = t8;
    const resolvedImageData = (0, $je216.useResolveImage)(link, imageData);
    let t10;
    let t9;
    if ($[0] !== extensionLocalId || $[1] !== index || $[2] !== selectedExtensionLocalId || $[3] !== selectedFrameIndex) {
        t9 = ()=>{
            if (cardRef.current && selectedFrameIndex === index && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) cardRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            });
        };
        t10 = [
            selectedFrameIndex,
            index,
            extensionLocalId,
            selectedExtensionLocalId
        ];
        $[0] = extensionLocalId;
        $[1] = index;
        $[2] = selectedExtensionLocalId;
        $[3] = selectedFrameIndex;
        $[4] = t10;
        $[5] = t9;
    } else {
        t10 = $[4];
        t9 = $[5];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($346548928aed178e$var$styles.frameStyles);
        $[6] = t11;
    } else t11 = $[6];
    let t12;
    if ($[7] !== width) {
        t12 = {
            width: width,
            minWidth: "100%"
        };
        $[7] = width;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== frameSetLength || $[10] !== index || $[11] !== intl) {
        t13 = intl.formatMessage((0, $VdC3b.messages).frameSpotlightLabel, {
            positionInSet: index + 1,
            setSize: frameSetLength
        });
        $[9] = frameSetLength;
        $[10] = index;
        $[11] = intl;
        $[12] = t13;
    } else t13 = $[12];
    const t14 = `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}${index}`;
    let t15;
    if ($[13] !== contentId || $[14] !== imageAltText || $[15] !== resolvedImageData) {
        t15 = $346548928aed178e$var$getImage(resolvedImageData, contentId, imageAltText);
        $[13] = contentId;
        $[14] = imageAltText;
        $[15] = resolvedImageData;
        $[16] = t15;
    } else t15 = $[16];
    const t16 = !!link;
    let t17;
    if ($[17] !== buttonStyle || $[18] !== buttonText || $[19] !== description || $[20] !== imageWidthPercentage || $[21] !== layout || $[22] !== link || $[23] !== source || $[24] !== t16 || $[25] !== textColor || $[26] !== title || $[27] !== width) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9n61H.SpotlightContent), {
            title: title,
            description: description,
            layout: layout,
            textColor: textColor,
            isButtonShown: t16,
            buttonStyle: buttonStyle,
            buttonText: buttonText,
            link: link,
            width: width,
            source: source,
            imageWidthPercentage: imageWidthPercentage
        });
        $[17] = buttonStyle;
        $[18] = buttonText;
        $[19] = description;
        $[20] = imageWidthPercentage;
        $[21] = layout;
        $[22] = link;
        $[23] = source;
        $[24] = t16;
        $[25] = textColor;
        $[26] = title;
        $[27] = width;
        $[28] = t17;
    } else t17 = $[28];
    let t18;
    if ($[29] !== backgroundColor || $[30] !== cornerRadiusOverride || $[31] !== hasRoundedCorners || $[32] !== height || $[33] !== imageWidthPercentage || $[34] !== layout || $[35] !== t15 || $[36] !== t17 || $[37] !== testId || $[38] !== width) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOuIh.SpotlightLayout), {
            testId: testId,
            backgroundColor: backgroundColor,
            height: height,
            layout: layout,
            image: t15,
            width: width,
            imageWidthPercentage: imageWidthPercentage,
            hasRoundedCorners: hasRoundedCorners,
            cornerRadiusOverride: cornerRadiusOverride
        }, t17);
        $[29] = backgroundColor;
        $[30] = cornerRadiusOverride;
        $[31] = hasRoundedCorners;
        $[32] = height;
        $[33] = imageWidthPercentage;
        $[34] = layout;
        $[35] = t15;
        $[36] = t17;
        $[37] = testId;
        $[38] = width;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t11,
            style: t12,
            "aria-label": t13,
            ref: cardRef,
            id: t14
        }, t18);
        $[40] = t12;
        $[41] = t13;
        $[42] = t14;
        $[43] = t18;
        $[44] = t19;
    } else t19 = $[44];
    return t19;
} : ({ testId: testId, contentId: contentId, source: source, link: link, title: title, description: description, backgroundColor: // default to neutral color for extensions who don't have this param set yet
// (aka v1 carousels), otherwise BG color will be set to a different default
// upon insertion, when Carousel V2 is enabled
backgroundColor = "var(--ds-background-input, #FFFFFF)", textColor: textColor = (0, $cT2iI.frameNewParametersV2)['textColor'], height: height, layout: layout = (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT, imageData: imageData, imageAltText: imageAltText, width: width, imageWidthPercentage: imageWidthPercentage, buttonStyle: buttonStyle = (0, $cT2iI.frameNewParametersV2)['buttonStyle'], buttonText: buttonText, hasRoundedCorners: hasRoundedCorners, cornerRadiusOverride: cornerRadiusOverride, index: index = 0, selectedFrameIndex: selectedFrameIndex = -1, frameSetLength: frameSetLength = 1, extensionLocalId: extensionLocalId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cardRef = (0, $cozmU.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $bIp5p.useExtensionsState)();
    const resolvedImageData = (0, $je216.useResolveImage)(link, imageData);
    (0, $cozmU.useEffect)(()=>{
        if (cardRef.current && selectedFrameIndex === index && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) cardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        selectedFrameIndex,
        index,
        extensionLocalId,
        selectedExtensionLocalId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($346548928aed178e$var$styles.frameStyles),
        style: {
            width: width,
            minWidth: '100%'
        },
        "aria-label": intl.formatMessage((0, $VdC3b.messages).frameSpotlightLabel, {
            positionInSet: index + 1,
            setSize: frameSetLength
        }),
        ref: cardRef,
        id: `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}${index}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOuIh.SpotlightLayout), {
        testId: testId,
        backgroundColor: backgroundColor,
        height: height,
        layout: layout,
        image: $346548928aed178e$var$getImage(resolvedImageData, contentId, imageAltText),
        width: width,
        imageWidthPercentage: imageWidthPercentage,
        hasRoundedCorners: hasRoundedCorners,
        cornerRadiusOverride: cornerRadiusOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9n61H.SpotlightContent), {
        title: title,
        description: description,
        layout: layout,
        textColor: textColor,
        isButtonShown: !!link,
        buttonStyle: buttonStyle,
        buttonText: buttonText,
        link: link,
        width: width,
        source: source,
        imageWidthPercentage: imageWidthPercentage
    })));
};
module.exports["CarouselLayoutRenderer"] = $346548928aed178e$export$d6098952608bbca6;

});

parcelRegister("je216", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3s2S5 = parcelRequire("3s2S5");

const $bcb193fec7dfca6e$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $bcb193fec7dfca6e$export$71956575015d1f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $bcb193fec7dfca6e$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $bcb193fec7dfca6e$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? "";
    return "";
} : (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $bcb193fec7dfca6e$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $bcb193fec7dfca6e$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};
module.exports["useResolveImage"] = $bcb193fec7dfca6e$export$71956575015d1f5;

});

parcelRegister("VdC3b", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d1d2b24fb44bd742$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    frameSpotlightLabel: {
        id: "company-hub.carousel-extension.frame-spotlight.label",
        defaultMessage: "frame {positionInSet} of {setSize}"
    }
});
module.exports["messages"] = $d1d2b24fb44bd742$export$defe85febe8b728c;

});


//# sourceMappingURL=cards-extension.598011cc.js.map
